(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3577],{

/***/ 93319:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[uid]",
      function () {
        return __webpack_require__(29295);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


function SliceManager(param) {
    var slicesClassName = param.slicesClassName, mapSliceTypeToComponent = param.mapSliceTypeToComponent, slicesData = param.slicesData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: slicesData === null || slicesData === void 0 ? void 0 : slicesData.map(function(sliceData, index) {
            var SliceComponent = mapSliceTypeToComponent === null || mapSliceTypeToComponent === void 0 ? void 0 : mapSliceTypeToComponent[sliceData === null || sliceData === void 0 ? void 0 : sliceData.type];
            if (!SliceComponent) return null;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliceComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                className: slicesClassName,
                index: index
            }, sliceData === null || sliceData === void 0 ? void 0 : sliceData.data), index);
        })
    });
}
SliceManager.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (SliceManager);


/***/ }),

/***/ 49013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18357);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38250);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);









var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()));
function VideoComponent(_param, ref) {
    var className = _param.className, loading = _param.loading, src = _param.src, rootMargin = _param.rootMargin, style = _param.style, sources = _param.sources, poster = _param.poster, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "loading",
        "src",
        "rootMargin",
        "style",
        "sources",
        "poster"
    ]);
    var shouldLazyLoad = loading === "lazy";
    var _$ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_6__/* .useInView */ .YD)({
        skip: !shouldLazyLoad,
        triggerOnce: true,
        rootMargin: rootMargin
    }), 2), inViewRef = _$ref[0], inView = _$ref[1];
    var setRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(node) {
        ref && (ref.current = node);
        inViewRef(node);
    }, [
        ref,
        inViewRef
    ]);
    var shouldHaveSrc = !shouldLazyLoad || shouldLazyLoad && inView;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        className: cx(className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().Video)),
        ref: setRef,
        src: shouldHaveSrc ? src : "",
        style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, style), {
            visibility: shouldHaveSrc ? "visible" : "hidden"
        }),
        poster: poster
    }, rest), {
        children: shouldHaveSrc && sources && sources.length > 0 && sources.map(function(source, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, source), "source".concat(index));
        })
    }));
}
var VideoComponentForwarded = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(VideoComponent);
VideoComponentForwarded.defaultProps = {
    loading: "eager",
    rootMargin: "200px 0px"
};
/* harmony default export */ __webpack_exports__["Z"] = (VideoComponentForwarded);


/***/ }),

/***/ 64354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18357);
/* harmony import */ var _providers_RecaptchaProvider_use_google_recaptcha__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99778);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24627);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
function RecaptchaHandler(param) {
    var className = param.className, children = param.children;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_6__/* .useInView */ .YD)({
        initialInView: false
    }), 2), inViewRef = ref[0], inView = ref[1];
    var loadRecaptcha = (0,_providers_RecaptchaProvider_use_google_recaptcha__WEBPACK_IMPORTED_MODULE_3__/* .useGoogleReCaptcha */ .x)().loadRecaptcha;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (inView) loadRecaptcha();
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: inViewRef,
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().RecaptchaHandler), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().marker)
            }),
            children
        ]
    });
}
RecaptchaHandler.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (RecaptchaHandler);


/***/ }),

/***/ 68971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ PageViewAnalytics; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13711);



function PageViewAnalytics(param) {
    var template = param.template;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = "".concat(router === null || router === void 0 ? void 0 : router.locale).concat(router === null || router === void 0 ? void 0 : router.pathname);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__/* .PageViewAnalytics */ .WA, {
        template: template,
        pathname: pathname
    });
}


/***/ }),

/***/ 37335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Link/index.js
var Link = __webpack_require__(13200);
// EXTERNAL MODULE: ./src/utils/alternate-url.ts
var alternate_url = __webpack_require__(50146);
;// CONCATENATED MODULE: ./src/components/Abstracts/Breadcrumb/serialize-json-ld.ts

function serializeJSONLD(param) {
    var links = param.links;
    return {
        itemListElements: links === null || links === void 0 ? void 0 : links.map(function(link, index) {
            return {
                position: "".concat(index + 1),
                name: link === null || link === void 0 ? void 0 : link.children,
                item: (link === null || link === void 0 ? void 0 : link.href) ? (0,alternate_url/* default */.Z)(link.href) : ""
            };
        })
    };
}

// EXTERNAL MODULE: ./src/components/Abstracts/Breadcrumb/styles.module.scss
var styles_module = __webpack_require__(11216);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/Breadcrumb/index.tsx









var cx = bind_default().bind((styles_module_default()));
function Breadcrumb(param) {
    var className = param.className, separatorClassName = param.separatorClassName, separatorItem = param.separatorItem, linkClassName = param.linkClassName, activeClassName = param.activeClassName, itemClassName = param.itemClassName, noLinkClassName = param.noLinkClassName, links = param.links;
    var t = (0,lib/* useTranslate */.qM)();
    var linksWithTrad = links === null || links === void 0 ? void 0 : links.map(function(link) {
        var ref, ref1;
        var isTradKey = typeof (link === null || link === void 0 ? void 0 : link.children) === "string" && (link === null || link === void 0 ? void 0 : (ref = link.children) === null || ref === void 0 ? void 0 : ref.includes("."));
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link), {
            children: isTradKey ? typeof (link === null || link === void 0 ? void 0 : link.children) === "string" && t(link === null || link === void 0 ? void 0 : (ref1 = link.children) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) : link === null || link === void 0 ? void 0 : link.children
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* BreadcrumbJsonLd */.gR, (0,_object_spread/* default */.Z)({}, serializeJSONLD({
                links: links
            }))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).Breadcrumb,
                children: linksWithTrad === null || linksWithTrad === void 0 ? void 0 : linksWithTrad.map(function(link, index) {
                    var isActive = index === links.length - 1;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: cx((styles_module_default()).item, itemClassName, isActive ? activeClassName : null),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,_object_spread/* default */.Z)({
                                className: cx((link === null || link === void 0 ? void 0 : link.href) ? null : ((styles_module_default()).noLink, noLinkClassName !== null && noLinkClassName !== void 0 ? noLinkClassName : null), (styles_module_default()).link, linkClassName)
                            }, link)),
                            index + 1 !== (links === null || links === void 0 ? void 0 : links.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: separatorClassName,
                                children: separatorItem !== null && separatorItem !== void 0 ? separatorItem : "/"
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
}
Breadcrumb.defaultProps = {};
/* harmony default export */ var Abstracts_Breadcrumb = (Breadcrumb);

// EXTERNAL MODULE: ./src/providers/BreadcrumbProvider/index.tsx
var BreadcrumbProvider = __webpack_require__(82082);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/components/UI/Breadcrumb/styles.module.scss
var Breadcrumb_styles_module = __webpack_require__(15028);
var Breadcrumb_styles_module_default = /*#__PURE__*/__webpack_require__.n(Breadcrumb_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/Breadcrumb/index.tsx











var Breadcrumb_cx = bind_default().bind((Breadcrumb_styles_module_default()));
function Breadcrumb_Breadcrumb(_param) {
    var className = _param.className, textPreset = _param.textPreset, textStyling = _param.textStyling, color = _param.color, theme = _param.theme, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "textPreset",
        "textStyling",
        "color",
        "theme"
    ]);
    var textStyle = (0,StyleProvider/* useStyle */.X)({
        color: color !== null && color !== void 0 ? color : colors/* GlobalThemeColors.Black */.b.Black,
        textPreset: textPreset !== null && textPreset !== void 0 ? textPreset : text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
        textStyling: textStyling !== null && textStyling !== void 0 ? textStyling : text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var links = (0,BreadcrumbProvider/* useBreadCrumb */.dp)().links;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Abstracts_Breadcrumb, (0,_object_spread/* default */.Z)({
        links: links,
        className: Breadcrumb_cx((Breadcrumb_styles_module_default()).Breadcrumb, textStyle, className, (Breadcrumb_styles_module_default()) === null || (Breadcrumb_styles_module_default()) === void 0 ? void 0 : (Breadcrumb_styles_module_default())["theme-".concat(theme)]),
        linkClassName: Breadcrumb_cx((Breadcrumb_styles_module_default()).link, textStyle),
        itemClassName: (Breadcrumb_styles_module_default()).item,
        activeClassName: (Breadcrumb_styles_module_default()).active,
        separatorClassName: (Breadcrumb_styles_module_default()).separator,
        noLinkClassName: (Breadcrumb_styles_module_default()).noLink,
        separatorItem: "•"
    }, rest));
}
Breadcrumb_Breadcrumb.defaultProps = {
    theme: "footer"
};
/* harmony default export */ var UI_Breadcrumb = (Breadcrumb_Breadcrumb);


/***/ }),

/***/ 29538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_polyglot__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14408);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37444);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95348);
/* harmony import */ var _components_UI_InlineCta__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85499);
/* harmony import */ var _data_dictionary__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9554);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10052);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()));
function ReadMoreText(param) {
    var className = param.className, text = param.text, charsLimit = param.charsLimit, hasReadLess = param.hasReadLess;
    var t = (0,react_polyglot__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var isTruncated = text && text.length > charsLimit;
    var truncatedText = isTruncated ? "".concat(text.slice(0, charsLimit), "...") : text;
    var shouldShowButton = hasReadLess ? isTruncated : isTruncated && !isOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().ReadMoreText), className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().truncatedText)),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().textItem),
                    children: isOpen ? text : truncatedText
                }),
                shouldShowButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_InlineCta__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Cta12Grotesk */ .C.Cta12Grotesk,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().descriptionCta),
                    theme: _types_colors__WEBPACK_IMPORTED_MODULE_4__/* .GlobalThemeColors.Black */ .b.Black,
                    onClick: function() {
                        return setIsOpen(!isOpen);
                    },
                    children: t(isOpen ? _data_dictionary__WEBPACK_IMPORTED_MODULE_7__/* .CTA.READ_LESS */ .MV.READ_LESS : _data_dictionary__WEBPACK_IMPORTED_MODULE_7__/* .CTA.READ_MORE */ .MV.READ_MORE)
                })
            ]
        })
    });
}
ReadMoreText.defaultProps = {
    hasReadLess: true
};
/* harmony default export */ __webpack_exports__["Z"] = (ReadMoreText);


/***/ }),

/***/ 97349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _hooks_useLocale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66794);
/* harmony import */ var _utils_locales__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40457);


function useMarket() {
    var locale = (0,_hooks_useLocale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return (0,_utils_locales__WEBPACK_IMPORTED_MODULE_1__/* .getMarketName */ .lA)(locale);
}
/* harmony default export */ __webpack_exports__["Z"] = (useMarket);


/***/ }),

/***/ 29295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _uid_Product; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/dist/index.mjs
var dist = __webpack_require__(18357);
;// CONCATENATED MODULE: ./src/imports/product_page.ts
/* harmony default export */ var product_page = ({});

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/JSONLD/Product/index.js + 1 modules
var Product = __webpack_require__(40064);
// EXTERNAL MODULE: ./src/components/Abstracts/SliceManager/index.tsx
var SliceManager = __webpack_require__(70820);
// EXTERNAL MODULE: ./src/components/PageViewAnalytics/index.tsx
var PageViewAnalytics = __webpack_require__(68971);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./src/lib/constants.ts + 3 modules
var constants = __webpack_require__(96660);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useIsomorphicLayoutEffect/index.js
var useIsomorphicLayoutEffect = __webpack_require__(56346);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./src/lib/process-cart-items.ts
var process_cart_items = __webpack_require__(51300);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Accordion/index.js
var Accordion = __webpack_require__(99385);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Accordion/AccordionPanel/index.js
var AccordionPanel = __webpack_require__(4903);
// EXTERNAL MODULE: ./src/components/Abstracts/AddToCartButton/index.tsx + 1 modules
var AddToCartButton = __webpack_require__(28542);
// EXTERNAL MODULE: ./src/components/Abstracts/PopIn/index.tsx
var PopIn = __webpack_require__(32671);
// EXTERNAL MODULE: ./src/components/Navigation/NavigationBanner/index.tsx
var NavigationBanner = __webpack_require__(64061);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/@types/alert.ts
var _types_alert = __webpack_require__(34969);
// EXTERNAL MODULE: ./src/@types/checkbox-preset.ts
var checkbox_preset = __webpack_require__(11867);
// EXTERNAL MODULE: ./src/@types/input-preset.ts
var input_preset = __webpack_require__(89419);
// EXTERNAL MODULE: ./src/components/Abstracts/RichText/index.tsx + 2 modules
var RichText = __webpack_require__(7191);
// EXTERNAL MODULE: ./src/components/Form/Checkbox/index.tsx + 12 modules
var Checkbox = __webpack_require__(90465);
// EXTERNAL MODULE: ./src/components/Form/ErrorList/index.tsx + 1 modules
var ErrorList = __webpack_require__(54404);
// EXTERNAL MODULE: ./src/components/Form/Input/index.tsx
var Input = __webpack_require__(55428);
// EXTERNAL MODULE: ./src/components/Form/RecaptchaHandler/index.tsx
var RecaptchaHandler = __webpack_require__(64354);
// EXTERNAL MODULE: ./src/components/UI/SquaredCta/index.tsx
var SquaredCta = __webpack_require__(35007);
// EXTERNAL MODULE: ./src/providers/GlobalDataProvider/index.tsx
var GlobalDataProvider = __webpack_require__(11036);
// EXTERNAL MODULE: ./src/providers/PopInProvider/index.tsx
var PopInProvider = __webpack_require__(18286);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/hooks/useAlerts/index.ts
var useAlerts = __webpack_require__(827);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/commerce-connector/dist/es/lib/gid.js
var gid = __webpack_require__(27643);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var yup_index_esm = __webpack_require__(16310);
// EXTERNAL MODULE: ./src/lib/handle-api.ts + 1 modules
var handle_api = __webpack_require__(16445);
// EXTERNAL MODULE: ./src/providers/RecaptchaProvider/use-google-recaptcha.tsx
var use_google_recaptcha = __webpack_require__(99778);
;// CONCATENATED MODULE: ./src/hooks/useStockAlertPopin/index.ts









var schema = (0,yup_index_esm/* object */.Ry)().shape({
    email: (0,yup_index_esm/* string */.Z_)().required().email().trim(),
    variantId: (0,yup_index_esm/* string */.Z_)(),
    productId: (0,yup_index_esm/* string */.Z_)(),
    redirectLink: (0,yup_index_esm/* string */.Z_)()
});
function useStockAlertPopin(formOptions, onSuccess, onError, onLoading) {
    var executeRecaptcha = (0,use_google_recaptcha/* useGoogleReCaptcha */.x)().executeRecaptcha;
    var form = (0,index_esm/* useForm */.cI)((0,_object_spread/* default */.Z)({
        resolver: (0,yup/* yupResolver */.X)(schema)
    }, formOptions));
    var stockAlertRegister = function(param) {
        var email = param.email, redirectLink = param.redirectLink, variantId = param.variantId, productId = param.productId;
        var payload = {
            email: email,
            products: [
                {
                    epi: (0,gid/* removeGidPrefix */.PF)(variantId),
                    empi: (0,gid/* removeGidPrefix */.PF)(productId),
                    du: redirectLink
                }, 
            ]
        };
        return (0,handle_api/* backInStockSubsribe */.a0)({
            payload: payload
        });
    };
    var onSubmit = form.handleSubmit(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var email, variantId, redirectLink, productId, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = param.email, variantId = param.variantId, redirectLink = param.redirectLink, productId = param.productId;
                        return [
                            4,
                            executeRecaptcha("stockAlert")
                        ];
                    case 1:
                        response = _state.sent();
                        if (response) {
                            stockAlertRegister({
                                email: email,
                                redirectLink: redirectLink,
                                variantId: variantId,
                                productId: productId
                            }), onSuccess();
                        } else {
                            onError();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }());
    return {
        form: form,
        onSubmit: onSubmit
    };
}

// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
// EXTERNAL MODULE: ./src/components/Popins/AlertStockPopin/styles.module.scss
var styles_module = __webpack_require__(51307);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Popins/AlertStockPopin/index.tsx



























var cx = bind_default().bind((styles_module_default()));
function AlertStockPopin(_param) {
    var className = _param.className, onSuccess = _param.onSuccess, variantId = _param.variantId, productId = _param.productId, productName = _param.productName, stockAlertProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "onSuccess",
        "variantId",
        "productId",
        "productName"
    ]);
    var ref;
    var ref1 = (0,GlobalDataProvider/* useGlobalData */.U)(), _global = ref1.global, alertStock = _global.popins.alertStock;
    var t = (0,lib/* useTranslate */.qM)();
    var triggerAlert = (0,useAlerts/* default */.Z)();
    var removeCurrent = (0,PopInProvider/* usePopIn */.wG)().removeCurrent;
    var ref2 = (0,react.useTransition)(), isPending = ref2[0], startTransition = ref2[1];
    var headerStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskMedium */.C.Text12GroteskMedium,
        color: colors/* GlobalThemeColors.Gray */.b.Gray,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Title24SangBleuLight */.C.Title24SangBleuLight,
        color: colors/* GlobalThemeColors.Black */.b.Black
    });
    var textStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12SangBleu */.C.Label12SangBleu,
        textStyling: text_styling/* GlobalTextStyling.Italic */.l.Italic,
        color: colors/* GlobalThemeColors.Gray */.b.Gray
    });
    var handleSuccess = function() {
        startTransition(function() {
            triggerAlert(_types_alert/* ALERT_CODES.ALERT_STOCK_SUCCESS */.p.ALERT_STOCK_SUCCESS);
            removeCurrent();
        });
    };
    var handleError = function() {
        startTransition(function() {
            triggerAlert();
        });
    };
    var ref3 = useStockAlertPopin({
        defaultValues: {
            redirectLink: stockAlertProps === null || stockAlertProps === void 0 ? void 0 : stockAlertProps.redirectLink,
            variantId: variantId,
            productId: productId
        }
    }, handleSuccess, handleError), form = ref3.form, onSubmit = ref3.onSubmit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx((styles_module_default()).AlertStockPopin, className),
        children: [
            (alertStock === null || alertStock === void 0 ? void 0 : alertStock.header) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx((styles_module_default()).header, headerStyle),
                children: (ref = alertStock.header) === null || ref === void 0 ? void 0 : ref.replace("%{value}", "".concat(productName))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                        className: cx((styles_module_default()).title, titleStyle),
                        render: alertStock === null || alertStock === void 0 ? void 0 : alertStock.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                        className: cx((styles_module_default()).text, textStyle),
                        render: alertStock === null || alertStock === void 0 ? void 0 : alertStock.text
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecaptchaHandler/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, form), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        onSubmit: onSubmit,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: cx((styles_module_default()).inputContainer),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (styles_module_default()).content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            preset: input_preset/* GlobalInputPreset.Email */.Y.Email,
                                            theme: colors/* GlobalThemeColors.Gray */.b.Gray
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                            className: cx((styles_module_default()).marketing),
                                            preset: checkbox_preset/* GlobalCheckboxPreset.AcceptsTerms */.t.AcceptsTerms,
                                            isRound: true,
                                            isSquared: false
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorList/* default */.Z, {
                                            className: cx((styles_module_default()).errorList)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SquaredCta/* default */.Z, {
                                    className: cx((styles_module_default()).button),
                                    isLoading: isPending,
                                    theme: colors/* GlobalThemeColors.Black */.b.Black,
                                    withBackground: true,
                                    withBorder: false,
                                    onClick: onSubmit,
                                    children: t(dictionary/* FORM.SUBMIT */.Yc.SUBMIT)
                                })
                            ]
                        })
                    })
                }))
            })
        ]
    });
}
AlertStockPopin.defaultProps = {};
/* harmony default export */ var Popins_AlertStockPopin = (AlertStockPopin);

// EXTERNAL MODULE: ./src/components/Popins/ContactPopin/index.tsx + 4 modules
var ContactPopin = __webpack_require__(41709);
// EXTERNAL MODULE: ./src/components/UI/Breadcrumb/index.tsx + 2 modules
var Breadcrumb = __webpack_require__(37335);
// EXTERNAL MODULE: ./src/components/UI/Icons/index.tsx + 17 modules
var Icons = __webpack_require__(54678);
// EXTERNAL MODULE: ./src/components/UI/InlineCta/index.tsx + 1 modules
var InlineCta = __webpack_require__(85499);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/lib/get-product-infos-from-product-state.ts


function getProductNoteFromProductState(param) {
    var isVariantAdjusting = param.isVariantAdjusting, isVariantSellable = param.isVariantSellable, isStockAlert = param.isStockAlert, isOutOfStock = param.isOutOfStock, isSpecialOrder = param.isSpecialOrder, isPreOrder = param.isPreOrder;
    if (isVariantSellable && isVariantAdjusting) {
        return constants/* PRODUCT_NOTES.ADJUSTABLE_FROM_SIZE_FOUND */.Df.ADJUSTABLE_FROM_SIZE_FOUND;
    }
    if (!isVariantSellable && isVariantAdjusting && !isPreOrder) {
        return constants/* PRODUCT_NOTES.NOT_ADJUSTABLE */.Df.NOT_ADJUSTABLE;
    }
    if (isStockAlert && isOutOfStock) {
        return constants/* PRODUCT_NOTES.STOCK_ALERT */.Df.STOCK_ALERT;
    }
    if (isSpecialOrder && isOutOfStock) {
        return constants/* PRODUCT_NOTES.SPECIAL_ORDER */.Df.SPECIAL_ORDER;
    }
    if (isPreOrder) {
        return constants/* PRODUCT_NOTES.PRE_ORDER */.Df.PRE_ORDER;
    }
    return null;
}
function getProductTextFromProductState(param) {
    var isAdjusting = param.isAdjusting, isThreeSizesVariants = param.isThreeSizesVariants, isVariantAdjusting = param.isVariantAdjusting, isVariantSellable = param.isVariantSellable, isOutOfStock = param.isOutOfStock, isSpecialOrder = param.isSpecialOrder;
    if (isAdjusting) {
        if (isVariantSellable && isVariantAdjusting) {
            return dictionary/* PRODUCT.SIZE_ADJUSTABLE */.c5.SIZE_ADJUSTABLE;
        }
        if (!isVariantSellable && isVariantAdjusting) {
            return dictionary/* PRODUCT.SIZE_ADJUSTABLE_NOT_POSSIBLE */.c5.SIZE_ADJUSTABLE_NOT_POSSIBLE;
        }
    } else {
        if (isOutOfStock) {
            if (isSpecialOrder) {
                return dictionary/* PRODUCT.SPECIAL_ORDER */.c5.SPECIAL_ORDER;
            }
            return dictionary/* PRODUCT.SOLDOUT */.c5.SOLDOUT;
        }
        if (isThreeSizesVariants) {
            return dictionary/* PRODUCT.SIZE_THREE */.c5.SIZE_THREE;
        }
    }
    return dictionary/* PRODUCT.SIZE_AVAILABLE */.c5.SIZE_AVAILABLE;
}

// EXTERNAL MODULE: ./src/components/UI/RichText/index.tsx
var UI_RichText = __webpack_require__(55071);
// EXTERNAL MODULE: ./src/hooks/useINPTrick/index.ts
var useINPTrick = __webpack_require__(20462);
// EXTERNAL MODULE: ./src/components/UI/ProductHeader/ProductDetailsBottomInformations/styles.module.scss
var ProductDetailsBottomInformations_styles_module = __webpack_require__(5096);
var ProductDetailsBottomInformations_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductDetailsBottomInformations_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/ProductHeader/ProductDetailsBottomInformations/index.tsx













var ProductDetailsBottomInformations_cx = bind_default().bind((ProductDetailsBottomInformations_styles_module_default()));
function ProductDetailsBottomInformations(param) {
    var className = param.className, isAdjusting = param.isAdjusting, hasSizeGuide = param.hasSizeGuide, hasSizeVariant = param.hasSizeVariant, isSpecialOrder = param.isSpecialOrder, isStockAlert = param.isStockAlert, isOutOfStock = param.isOutOfStock, isUniqueVariant = param.isUniqueVariant, isThreeSizesVariants = param.isThreeSizesVariants, isVariantAdjusting = param.isVariantAdjusting, isVariantSellable = param.isVariantSellable, onClickSizeGuide = param.onClickSizeGuide, preOrder = param.preOrder, notes = param.notes, uniqueVariantSize = param.uniqueVariantSize;
    var t = (0,lib/* useTranslate */.qM)();
    var ref = (0,useINPTrick/* useINPTrick */.z)(), hasInteracted = ref.hasInteracted, onInteract = ref.onInteract;
    var textInfosStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskRegular */.C.Text12GroteskRegular
    });
    var noteLabelStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskMedium */.C.Text12GroteskMedium,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var noteTextStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12SangBleu */.C.Label12SangBleu,
        textStyling: text_styling/* GlobalTextStyling.Italic */.l.Italic
    });
    var ref1;
    var currentNote = (ref1 = notes === null || notes === void 0 ? void 0 : notes[getProductNoteFromProductState({
        isVariantAdjusting: isVariantAdjusting,
        isVariantSellable: isVariantSellable,
        isStockAlert: isStockAlert,
        isOutOfStock: isOutOfStock,
        isSpecialOrder: isSpecialOrder,
        isPreOrder: preOrder === null || preOrder === void 0 ? void 0 : preOrder.isActive
    })]) !== null && ref1 !== void 0 ? ref1 : "" // Keep something empty to avoid shifting
    ;
    var ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ProductDetailsBottomInformations_cx((ProductDetailsBottomInformations_styles_module_default()).ProductDetailsBottomInformations, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProductDetailsBottomInformations_styles_module_default()).top,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: ProductDetailsBottomInformations_cx((ProductDetailsBottomInformations_styles_module_default()).textInfos, textInfosStyle),
                        children: isUniqueVariant ? uniqueVariantSize && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: ProductDetailsBottomInformations_cx((ProductDetailsBottomInformations_styles_module_default()).size, {
                                isOutOfStock: isOutOfStock
                            }),
                            children: uniqueVariantSize
                        }) : t(getProductTextFromProductState({
                            isAdjusting: isAdjusting,
                            isThreeSizesVariants: isThreeSizesVariants,
                            isVariantAdjusting: isVariantAdjusting,
                            isVariantSellable: isVariantSellable,
                            isOutOfStock: isOutOfStock,
                            isSpecialOrder: isSpecialOrder
                        }))
                    }),
                    hasSizeGuide && hasSizeVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductDetailsBottomInformations_styles_module_default()).toggleSizeGuide,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, {
                            className: ProductDetailsBottomInformations_cx((ProductDetailsBottomInformations_styles_module_default()).sizeGuideButton, hasInteracted && (ProductDetailsBottomInformations_styles_module_default()).hasInteracted),
                            textPreset: text_preset/* GlobalTextPreset.Cta10GroteskRegular */.C.Cta10GroteskRegular,
                            onClick: function(e) {
                                return onInteract(function() {
                                    return onClickSizeGuide(e);
                                });
                            },
                            children: t(dictionary/* CTA.SIZE_GUIDE */.MV.SIZE_GUIDE)
                        })
                    })
                ]
            }),
            currentNote && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProductDetailsBottomInformations_styles_module_default()).bottom,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ProductDetailsBottomInformations_styles_module_default()).note,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: ProductDetailsBottomInformations_cx((ProductDetailsBottomInformations_styles_module_default()).noteTitle, noteLabelStyle),
                            children: "Note\xa0:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_RichText/* default */.Z, {
                            replacePatterns: (preOrder === null || preOrder === void 0 ? void 0 : preOrder.isActive) ? [
                                {
                                    stringToReplace: "%{delivery_date}",
                                    replacementString: (ref2 = preOrder === null || preOrder === void 0 ? void 0 : preOrder.deliveryDate) !== null && ref2 !== void 0 ? ref2 : ""
                                }, 
                            ] : null,
                            render: currentNote,
                            className: ProductDetailsBottomInformations_cx((ProductDetailsBottomInformations_styles_module_default()).noteText, noteTextStyle)
                        })
                    ]
                })
            })
        ]
    });
}
ProductDetailsBottomInformations.defaultProps = {};
/* harmony default export */ var ProductHeader_ProductDetailsBottomInformations = (ProductDetailsBottomInformations);

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-slider/dist/es/hooks/useSliderState/index.js
var useSliderState = __webpack_require__(80581);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-slider/dist/es/index.js + 19 modules
var es = __webpack_require__(7924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/components/Abstracts/Cta/index.tsx + 1 modules
var Cta = __webpack_require__(57161);
// EXTERNAL MODULE: ./src/components/UI/SliderArrow/styles.module.scss
var SliderArrow_styles_module = __webpack_require__(28657);
var SliderArrow_styles_module_default = /*#__PURE__*/__webpack_require__.n(SliderArrow_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/SliderArrow/index.tsx










var SliderArrow_cx = bind_default().bind((SliderArrow_styles_module_default()));
function SliderArrow(_param) {
    var className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cta/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        theme: colors/* GlobalThemeColors.Black */.b.Black,
        css: (SliderArrow_styles_module_default()),
        cx: SliderArrow_cx,
        className: SliderArrow_cx(className, (SliderArrow_styles_module_default()).SliderArrow)
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* DownIcon */.KL, {
            className: SliderArrow_cx((SliderArrow_styles_module_default()).arrowIcon)
        })
    }));
}
SliderArrow.defaultProps = {};
/* harmony default export */ var UI_SliderArrow = (SliderArrow);

// EXTERNAL MODULE: ./src/components/UI/SliderArrows/styles.module.scss
var SliderArrows_styles_module = __webpack_require__(99930);
var SliderArrows_styles_module_default = /*#__PURE__*/__webpack_require__.n(SliderArrows_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/SliderArrows/index.tsx






var SliderArrows_cx = bind_default().bind((SliderArrows_styles_module_default()));
function SliderArrows(param) {
    var prevSlide = param.prevSlide, nextSlide = param.nextSlide, layout = param.layout, buttonClassName = param.buttonClassName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_SliderArrow, {
                onClick: prevSlide,
                className: SliderArrows_cx((SliderArrows_styles_module_default()).sliderArrow, (SliderArrows_styles_module_default()).leftArrow, buttonClassName, (0,_define_property/* default */.Z)({}, layout, layout))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_SliderArrow, {
                onClick: nextSlide,
                className: SliderArrows_cx((SliderArrows_styles_module_default()).sliderArrow, (SliderArrows_styles_module_default()).rightArrow, buttonClassName, (0,_define_property/* default */.Z)({}, layout, layout))
            })
        ]
    });
}
SliderArrows.defaultProps = {};
/* harmony default export */ var UI_SliderArrows = (SliderArrows);

// EXTERNAL MODULE: ./src/utils/get-css-theme-classname.ts
var get_css_theme_classname = __webpack_require__(89648);
// EXTERNAL MODULE: ./src/components/UI/ProductHeader/ProductSliderSelect/styles.module.scss
var ProductSliderSelect_styles_module = __webpack_require__(39641);
var ProductSliderSelect_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductSliderSelect_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/ProductHeader/ProductSliderSelect/index.tsx











var ProductSliderSelect_cx = bind_default().bind((ProductSliderSelect_styles_module_default()));
function ProductSliderSelect(param) {
    var className = param.className, hasArrows = param.hasArrows, items = param.items, theme = param.theme, onChange = param.onChange;
    var customSliderRef = (0,react.useRef)(null);
    var buttonStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Cta12GroteskRegular */.C.Cta12GroteskRegular,
        textStyling: text_styling/* GlobalTextStyling.Capitalize */.l.Capitalize
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,useSliderState/* default */.Z)(), 2), ref1 = ref[0], nextSlide = ref1.nextSlide, prevSlide = ref1.prevSlide, enableDrag = ref1.enableDrag, setSliderState = ref[1];
    //Todo uncomment with slider newest versions
    /*  { enableDrag: true }, */ var themeClassName = theme ? (0,get_css_theme_classname/* getCSSThemeClassName */.C)((ProductSliderSelect_styles_module_default()), theme, {
        prefix: "theme-"
    }) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ProductSliderSelect_cx((ProductSliderSelect_styles_module_default()).ProductSliderSelect, className, themeClassName, {
            hasArrows: enableDrag && hasArrows
        }),
        ref: customSliderRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProductSliderSelect_styles_module_default()).wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.ZP, {
                    className: (ProductSliderSelect_styles_module_default()).slider,
                    customSliderRef: customSliderRef,
                    maxSlideIndexChange: 1,
                    setSliderState: setSliderState,
                    autoIsSlider: true,
                    snap: true,
                    children: items === null || items === void 0 ? void 0 : items.map(function(param, index) {
                        var label = param.label, value = param.value, selected = param.selected, disabled = param.disabled, isOutOfStock = param.isOutOfStock;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: ProductSliderSelect_cx((ProductSliderSelect_styles_module_default()).button, buttonStyle, {
                                isSelected: selected,
                                isDisabled: disabled,
                                isOutOfStock: isOutOfStock
                            }),
                            onClick: function() {
                                onChange && onChange(value, label);
                            },
                            children: label
                        }, "button_".concat(index));
                    })
                })
            }),
            enableDrag && hasArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_SliderArrows, {
                buttonClassName: (ProductSliderSelect_styles_module_default()).sliderArrow,
                layout: "inside",
                nextSlide: nextSlide,
                prevSlide: prevSlide
            })
        ]
    });
}
ProductSliderSelect.defaultProps = {
    theme: "large",
    hasArrows: true
};
/* harmony default export */ var ProductHeader_ProductSliderSelect = (ProductSliderSelect);

// EXTERNAL MODULE: ./src/components/Form/Select/index.tsx + 1 modules
var Select = __webpack_require__(60043);
// EXTERNAL MODULE: ./src/components/UI/ProductHeader/ProductVariationsSelect/styles.module.scss
var ProductVariationsSelect_styles_module = __webpack_require__(75278);
var ProductVariationsSelect_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductVariationsSelect_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/ProductHeader/ProductVariationsSelect/index.tsx







var ProductVariationsSelect_cx = bind_default().bind((ProductVariationsSelect_styles_module_default()));
function ProductVariationsSelect(param) {
    var mainCss = param.mainCss, items = param.items, active = param.active;
    var router = (0,next_router.useRouter)();
    var selectItems = items === null || items === void 0 ? void 0 : items.map(function(item, index) {
        var ref;
        return {
            label: item === null || item === void 0 ? void 0 : item.label,
            value: item === null || item === void 0 ? void 0 : (ref = item.link) === null || ref === void 0 ? void 0 : ref.href.toString(),
            selected: (item === null || item === void 0 ? void 0 : item.uuid) === (active === null || active === void 0 ? void 0 : active.uuid),
            disabled: (item === null || item === void 0 ? void 0 : item.uuid) === (active === null || active === void 0 ? void 0 : active.uuid)
        };
    });
    var onChangeItem = function(href) {
        router.push(href);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                options: selectItems,
                className: ProductVariationsSelect_cx(mainCss.select, mainCss.hideOnSmallScreen),
                onChange: function(e) {
                    onChangeItem(e.target.value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHeader_ProductSliderSelect, {
                theme: "small",
                className: ProductVariationsSelect_cx(mainCss.select, mainCss.hideOnLargeScreen),
                items: selectItems,
                onChange: function(value) {
                    onChangeItem(value);
                }
            })
        ]
    });
}
ProductVariationsSelect.defaultProps = {};
/* harmony default export */ var ProductHeader_ProductVariationsSelect = (ProductVariationsSelect);

// EXTERNAL MODULE: ./src/utils/is-size-or-default-variant-name.ts
var is_size_or_default_variant_name = __webpack_require__(64349);
// EXTERNAL MODULE: ./src/utils/variant-helpers.ts
var variant_helpers = __webpack_require__(83771);
// EXTERNAL MODULE: ./src/components/UI/ProductHeader/ProductHeaderVariants/styles.module.scss
var ProductHeaderVariants_styles_module = __webpack_require__(37870);
var ProductHeaderVariants_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductHeaderVariants_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/ProductHeader/ProductHeaderVariants/index.tsx















var ProductSizeGuide = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1385).then(__webpack_require__.bind(__webpack_require__, 21385));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21385)
            ];
        }
    }
});
var ProductHeaderVariants_cx = bind_default().bind((ProductHeaderVariants_styles_module_default()));
function ProductHeaderVariants(param) {
    var className = param.className, notes = param.notes, variants = param.variants, selectedVariant = param.selectedVariant, hasSizeGuide = param.hasSizeGuide, setSelectedVariant = param.setSelectedVariant, isStockAlert = param.isStockAlert, isSpecialOrder = param.isSpecialOrder, isAdjusting = param.isAdjusting, preOrder = param.preOrder, productVariations = param.productVariations, sizeGuide = param.sizeGuide, setCustomProductState = param.setCustomProductState;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), isSizeGuideVisible = ref1[0], setIsSizeGuideVisible = ref1[1];
    var selectedVariantAvailableForSale = (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.availableForSale) && !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.currentlyNotInStock);
    var selectedVariantOutOfStock = !selectedVariantAvailableForSale && !(preOrder === null || preOrder === void 0 ? void 0 : preOrder.isActive);
    var ref2;
    var options = (ref2 = variants === null || variants === void 0 ? void 0 : variants.reduce(function(acc, variant) {
        var ref;
        variant === null || variant === void 0 ? void 0 : (ref = variant.selectedOptions) === null || ref === void 0 ? void 0 : ref.forEach(function(option) {
            var ref, ref1;
            if (!acc[option.name]) {
                acc[option.name] = [];
            }
            var ref2;
            var selectedOptions = (0,_to_consumable_array/* default */.Z)((ref2 = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.selectedOptions) === null || ref === void 0 ? void 0 : (ref1 = ref.filter) === null || ref1 === void 0 ? void 0 : ref1.call(ref, function(selectedOption) {
                return selectedOption.name !== option.name;
            })) !== null && ref2 !== void 0 ? ref2 : []).concat([
                option, 
            ]);
            var _$variant = (0,variant_helpers/* getVariantFromSelectedOptions */._)(selectedOptions, variants);
            if (_$variant && !acc[option.name].find(function(v) {
                return v.id === _$variant.id && (isAdjusting ? v.title === _$variant.title : true);
            })) {
                acc[option.name].push((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, _$variant), {
                    title: option.value
                }));
            }
        });
        return acc;
    }, {})) !== null && ref2 !== void 0 ? ref2 : {};
    var variantKeys = Object.keys(options);
    var ref3;
    var hasSizeVariant = (ref3 = ((ref = variantKeys === null || variantKeys === void 0 ? void 0 : variantKeys.filter(function(key) {
        return (0,is_size_or_default_variant_name/* isSizeOrDefaultVariantName */.j)(key);
    })) === null || ref === void 0 ? void 0 : ref.length) > 0) !== null && ref3 !== void 0 ? ref3 : false;
    var getUniqueVariantSize = function() {
        var ref, ref1, ref2;
        if (!isUniqueVariant) return null;
        var size = (ref2 = variants === null || variants === void 0 ? void 0 : (ref = variants[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.selectedOptions) === null || ref1 === void 0 ? void 0 : ref1.find(function(option) {
            var ref;
            return constants/* SHOPIFY_VARIANT_SELECTED_OPTION_SIZES_NAME */.oQ === null || constants/* SHOPIFY_VARIANT_SELECTED_OPTION_SIZES_NAME */.oQ === void 0 ? void 0 : constants/* SHOPIFY_VARIANT_SELECTED_OPTION_SIZES_NAME.includes */.oQ.includes(option === null || option === void 0 ? void 0 : (ref = option.name) === null || ref === void 0 ? void 0 : ref.toUpperCase());
        })) === null || ref2 === void 0 ? void 0 : ref2.value;
        return !isNaN(parseInt(size)) ? size : null;
    };
    var isUniqueVariant = (variants === null || variants === void 0 ? void 0 : variants.length) <= 1;
    var isThreeSizesVariants = hasSizeVariant && (variants === null || variants === void 0 ? void 0 : variants.length) === 3;
    var onChangeVariant = function(id, title) {
        var targetVariant = variants === null || variants === void 0 ? void 0 : variants.find(function(variant) {
            return (variant === null || variant === void 0 ? void 0 : variant.id) === id && (isAdjusting ? (variant === null || variant === void 0 ? void 0 : variant.title) === title : true);
        });
        setSelectedVariant(targetVariant);
        router.push({
            pathname: router.pathname,
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router === null || router === void 0 ? void 0 : router.query), {
                variant: targetVariant.title
            })
        }, undefined, {
            shallow: true
        });
    };
    var onClickSizeGuide = function() {
        setIsSizeGuideVisible(true);
    };
    var onCloseSizeGuide = function() {
        setIsSizeGuideVisible(false);
    };
    (0,react.useEffect)(function() {
        if (hasSizeVariant) {
            if (isAdjusting) {
                if ((selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isVariantAdjusting) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isVariantSellable)) {
                    setCustomProductState(function(prevValue) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValue), {
                            isAdjusting: true
                        });
                    });
                } else {
                    setCustomProductState(function(prevValue) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValue), {
                            isAdjusting: false
                        });
                    });
                }
            }
            setCustomProductState(function(prevValue) {
                var ref, ref1;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValue), {
                    selectedSize: (ref1 = selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.selectedOptions) === null || ref === void 0 ? void 0 : ref.find(function(option) {
                        return (0,is_size_or_default_variant_name/* isSizeOrDefaultVariantName */.j)(option.name);
                    })) === null || ref1 === void 0 ? void 0 : ref1.value
                });
            });
        }
        if (preOrder) {
            setCustomProductState(function(prevValue) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValue), {
                    isPreOrder: preOrder === null || preOrder === void 0 ? void 0 : preOrder.isActive
                });
            });
        }
        if (isUniqueVariant) {
            setCustomProductState(function(prevValue) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevValue), {
                    isUniqueSize: true
                });
            });
        }
    }, [
        selectedVariant,
        hasSizeVariant,
        isUniqueVariant,
        isAdjusting,
        preOrder
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ProductHeaderVariants_cx(className, (ProductHeaderVariants_styles_module_default()).ProductHeaderVariants),
        children: [
            (variants === null || variants === void 0 ? void 0 : variants.length) > 1 && (variantKeys === null || variantKeys === void 0 ? void 0 : variantKeys.map(function(key) {
                var isSize = (0,is_size_or_default_variant_name/* isSizeOrDefaultVariantName */.j)(key);
                var selectVariants = options[key];
                var selectOptions = selectVariants === null || selectVariants === void 0 ? void 0 : selectVariants.map(function(variant) {
                    var variantAvailableForSale = (variant === null || variant === void 0 ? void 0 : variant.availableForSale) && !(variant === null || variant === void 0 ? void 0 : variant.currentlyNotInStock);
                    var variantOutOfStock = !isAdjusting && !variantAvailableForSale && !(preOrder === null || preOrder === void 0 ? void 0 : preOrder.isActive);
                    return {
                        label: "".concat(variant === null || variant === void 0 ? void 0 : variant.title).concat(isSize && (variant === null || variant === void 0 ? void 0 : variant.isVariantAdjusting) ? "*" : ""),
                        value: variant === null || variant === void 0 ? void 0 : variant.id,
                        selected: (variant === null || variant === void 0 ? void 0 : variant.id) === (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id) && (isAdjusting ? (variant === null || variant === void 0 ? void 0 : variant.title) === (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.title) : true),
                        disabled: isSize && !variantAvailableForSale,
                        isOutOfStock: variantOutOfStock
                    };
                });
                return isSize ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHeader_ProductSliderSelect, {
                    theme: "large",
                    className: (ProductHeaderVariants_styles_module_default()).sizeSelect,
                    items: selectOptions,
                    onChange: function(id, value) {
                        var processedValue = value === null || value === void 0 ? void 0 : value.replace("*", "");
                        onChangeVariant(id, processedValue);
                    }
                }, "size_select_".concat(key)) : null;
            })),
            productVariations && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHeader_ProductVariationsSelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, productVariations), {
                className: (ProductHeaderVariants_styles_module_default()).productVariations,
                mainCss: (ProductHeaderVariants_styles_module_default())
            })),
            hasSizeGuide && hasSizeVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSizeGuide, (0,_object_spread/* default */.Z)({
                className: (ProductHeaderVariants_styles_module_default()).productSizeGuide,
                isSizeGuideVisible: isSizeGuideVisible,
                onClose: function() {
                    onCloseSizeGuide();
                }
            }, sizeGuide)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHeader_ProductDetailsBottomInformations, {
                className: ProductHeaderVariants_cx((ProductHeaderVariants_styles_module_default()).bottomInformations, {
                    hasVariants: (variants === null || variants === void 0 ? void 0 : variants.length) > 1
                }),
                hasSizeGuide: hasSizeGuide,
                hasSizeVariant: hasSizeVariant,
                preOrder: preOrder,
                isUniqueVariant: isUniqueVariant,
                isThreeSizesVariants: isThreeSizesVariants,
                isVariantAdjusting: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isVariantAdjusting,
                isVariantSellable: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.isVariantSellable,
                isAdjusting: isAdjusting,
                isSpecialOrder: isSpecialOrder,
                isStockAlert: isStockAlert,
                isOutOfStock: selectedVariantOutOfStock,
                onClickSizeGuide: onClickSizeGuide,
                notes: notes,
                uniqueVariantSize: getUniqueVariantSize()
            })
        ]
    });
}
ProductHeaderVariants.defaultProps = {};
/* harmony default export */ var ProductHeader_ProductHeaderVariants = (ProductHeaderVariants);

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useIsHover/index.js
var useIsHover = __webpack_require__(61356);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useDeviceType/index.js
var useDeviceType = __webpack_require__(9011);
// EXTERNAL MODULE: ./src/components/UI/ProductReassurance/styles.module.scss
var ProductReassurance_styles_module = __webpack_require__(63464);
var ProductReassurance_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductReassurance_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/ProductReassurance/index.tsx













var ProductReassurance_cx = bind_default().bind((ProductReassurance_styles_module_default()));
function ProductReassurance(param) {
    var className = param.className, items = param.items;
    var customSliderRef = (0,react.useRef)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useIsHover/* useIsHover */.c)(), 2), isHovered = ref[0], callbacks = ref[1];
    var device = (0,useDeviceType/* useDeviceType */.h)();
    var isHovering = device === useDeviceType/* DeviceType.mobile */.Y.mobile ? false : isHovered;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: ProductReassurance_cx((ProductReassurance_styles_module_default()).ProductReassurance, className)
    }, callbacks), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ProductReassurance_styles_module_default()).wrapper,
            ref: customSliderRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.ZP, {
                className: ProductReassurance_cx((ProductReassurance_styles_module_default()).slider),
                infinite: true,
                autoIsSlider: false,
                customSliderRef: customSliderRef,
                autoPlay: {
                    speed: isHovering ? 0 : -0.2
                },
                children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                    var hasLink = !!(item === null || item === void 0 ? void 0 : item.href);
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductReassurance_styles_module_default()).item,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread/* default */.Z)({
                                isDiv: !hasLink,
                                textPreset: text_preset/* GlobalTextPreset.Cta12GroteskRegular */.C.Cta12GroteskRegular,
                                textStyling: text_styling/* GlobalTextStyling.Capitalize */.l.Capitalize,
                                theme: colors/* GlobalThemeColors.Gray */.b.Gray,
                                lineProps: {
                                    isVisible: hasLink
                                }
                            }, item)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (ProductReassurance_styles_module_default()).separator,
                                children: "•"
                            })
                        ]
                    }, "reassurance_items_".concat(index));
                })
            })
        })
    }));
}
ProductReassurance.defaultProps = {};
/* harmony default export */ var UI_ProductReassurance = (ProductReassurance);

// EXTERNAL MODULE: ./src/components/UI/ReadMoreText/index.tsx
var ReadMoreText = __webpack_require__(29538);
// EXTERNAL MODULE: ./src/components/UI/WishlistIcon/index.tsx + 3 modules
var WishlistIcon = __webpack_require__(39760);
// EXTERNAL MODULE: ./src/providers/SettingsProvider/index.tsx
var SettingsProvider = __webpack_require__(25828);
// EXTERNAL MODULE: ./src/hooks/useLang/index.ts
var useLang = __webpack_require__(7078);
// EXTERNAL MODULE: ./src/hooks/useMarket/index.ts
var useMarket = __webpack_require__(97349);
// EXTERNAL MODULE: ./src/components/UI/ProductHeader/ProductDetails/styles.module.scss
var ProductDetails_styles_module = __webpack_require__(71843);
var ProductDetails_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductDetails_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/ProductHeader/ProductDetails/index.tsx




































var ProductDetails_cx = bind_default().bind((ProductDetails_styles_module_default()));
var defaultProductCustomState = {
    selectedSize: null,
    isUniqueSize: false,
    isPreOrder: false,
    isAdjusting: false
};
function ProductDetailsAccordion(param) {
    var className = param.className, items = param.items;
    var headlineStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label11GroteskRegular */.C.Label11GroteskRegular,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    var bodyStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskRegular */.C.Text12GroteskRegular
    });
    var t = (0,lib/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* Accordion */.UQ, {
            className: ProductDetails_cx((ProductDetails_styles_module_default()).accordion, className),
            children: items === null || items === void 0 ? void 0 : items.map(function(param, key) {
                var headline = param.headline, text = param.text;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionPanel/* AccordionPanel */.H, {
                    className: ProductDetails_cx((ProductDetails_styles_module_default()).panel),
                    index: key,
                    head: function(isActive) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: ProductDetails_cx((ProductDetails_styles_module_default()).panelHead, {
                                isActive: isActive
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: ProductDetails_cx((ProductDetails_styles_module_default()).title, headlineStyle),
                                    children: t(headline)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* DownIcon */.KL, {
                                    className: ProductDetails_cx((ProductDetails_styles_module_default()).icon, {
                                        isActive: isActive
                                    })
                                })
                            ]
                        });
                    },
                    body: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: ProductDetails_cx((ProductDetails_styles_module_default()).panelBody, bodyStyle),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_RichText/* default */.Z, {
                            className: ProductDetails_cx((ProductDetails_styles_module_default()).text),
                            render: text
                        })
                    })
                }, "panel_".concat(key));
            })
        })
    });
}
function ProductDetails(param) {
    var className = param.className, slug = param.slug, shopifyId = param.shopifyId, cardImage = param.cardImage, productName = param.productName, productDesigner = param.productDesigner, variants = param.variants, selectedVariant = param.selectedVariant, sizeGuide = param.sizeGuide, reference = param.reference, description = param.description, sections = param.sections, isQuickbuy = param.isQuickbuy, setSelectedVariant = param.setSelectedVariant, onAddToCart = param.onAddToCart, trackingData = param.trackingData, isAdjusting = param.isAdjusting, adjustableOffset = param.adjustableOffset, isStockAlert = param.isStockAlert, isSpecialOrder = param.isSpecialOrder, preOrder = param.preOrder, link = param.link, productVariations = param.productVariations, stockAlertProps = param.stockAlertProps, firstImage = param.firstImage, uuid = param.uuid;
    var ref, ref1, ref2, ref3;
    var market = (0,useMarket/* default */.Z)();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,NavigationBanner/* useNavBannerContext */.DI)(), 1), isNavBannerVisible = ref4[0];
    var ref5 = (0,SettingsProvider/* useSettings */.rV)(), wishlistEnabled = ref5.wishlistEnabled, stockAlertEnabled = ref5.stockAlertEnabled;
    var global = (0,GlobalDataProvider/* useGlobalData */.U)().global;
    var lang = (0,useLang/* default */.Z)();
    var productAvailableForSale = (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.availableForSale) && !(selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.currentlyNotInStock);
    var enablePreOrder = (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.currentlyNotInStock) && (preOrder === null || preOrder === void 0 ? void 0 : preOrder.isActive);
    var isOutOfSkock = !productAvailableForSale && !enablePreOrder;
    var ref6 = (0,react.useState)(defaultProductCustomState), customProductState = ref6[0], setCustomProductState = ref6[1];
    var ref7 = (0,react.useState)(1), quantity = ref7[0];
    var t = (0,lib/* useTranslate */.qM)();
    var ref8 = (0,PopInProvider/* usePopIn */.wG)(), addPopin = ref8.add, removeCurrent = ref8.removeCurrent;
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12Grotesk */.C.Label12Grotesk
    });
    var textStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskRegular */.C.Text12GroteskRegular
    });
    var compareAtStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskRegular */.C.Text12GroteskRegular,
        color: colors/* GlobalThemeColors.Gray */.b.Gray
    });
    var addToCartActions = function() {
        removeCurrent();
        onAddToCart === null || onAddToCart === void 0 ? void 0 : onAddToCart();
    };
    var ref9, ref10, ref11, ref12;
    var cartItems = (0,process_cart_items/* processCartItems */.l)({
        merchandiseId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
        quantity: quantity,
        attributes: (0,_object_spread/* default */.Z)({
            lang: lang,
            slug: slug,
            name: productName,
            designer: (ref9 = productDesigner === null || productDesigner === void 0 ? void 0 : (ref = productDesigner.children) === null || ref === void 0 ? void 0 : ref.toString()) !== null && ref9 !== void 0 ? ref9 : null,
            reference: reference !== null && reference !== void 0 ? reference : null,
            image: (ref11 = (ref10 = cardImage === null || cardImage === void 0 ? void 0 : cardImage.src) !== null && ref10 !== void 0 ? ref10 : firstImage === null || firstImage === void 0 ? void 0 : firstImage.src) !== null && ref11 !== void 0 ? ref11 : null,
            shopifyId: shopifyId,
            trackingData: (ref12 = JSON.stringify(trackingData, function(key, value) {
                var ref;
                return typeof value === "string" ? (ref = encodeURI(value)) === null || ref === void 0 ? void 0 : ref.replace(/'/g, "`") : value;
            })) !== null && ref12 !== void 0 ? ref12 : ""
        }, customProductState)
    });
    var ref13 = (0,dist/* useInView */.YD)({
        threshold: 0.2,
        initialInView: true
    }), inViewTopMarkerRef = ref13.ref;
    var showStockAlertPopin = function() {
        return addPopin(/*#__PURE__*/ (0,jsx_runtime.jsx)(PopIn/* default */.ZP, {
            className: ProductDetails_cx((ProductDetails_styles_module_default()).popin),
            isCloseButton: true,
            closeButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CloseIcon */.Tw, {
                className: (ProductDetails_styles_module_default()).alertStockIconClose
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popins_AlertStockPopin, (0,_object_spread/* default */.Z)({
                className: ProductDetails_cx((ProductDetails_styles_module_default()).alertStock),
                variantId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
                productId: shopifyId
            }, stockAlertProps))
        }));
    };
    var showContactPopin = function() {
        return addPopin(/*#__PURE__*/ (0,jsx_runtime.jsx)(PopIn/* default */.ZP, {
            className: ProductDetails_cx((ProductDetails_styles_module_default()).popin),
            isCloseButton: true,
            closeButton: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CloseIcon */.Tw, {
                className: (ProductDetails_styles_module_default()).alertStockIconClose
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactPopin/* default */.Z, {
                className: ProductDetails_cx((ProductDetails_styles_module_default()).contactPopin)
            })
        }));
    };
    var renderCtas = function(isStockAlert, isSpecialOrder, selectedVariant) {
        if (isStockAlert && stockAlertEnabled && !productAvailableForSale) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SquaredCta/* default */.Z, {
                className: ProductDetails_cx((ProductDetails_styles_module_default()).addToCart, (ProductDetails_styles_module_default()).isOutOfStock),
                theme: colors/* GlobalThemeColors.Black */.b.Black,
                textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
                onClick: showStockAlertPopin,
                children: t(dictionary/* CTA.QUICKBUY_STOCK_ALERT */.MV.QUICKBUY_STOCK_ALERT)
            });
        }
        if (isSpecialOrder && !productAvailableForSale) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SquaredCta/* default */.Z, {
                className: ProductDetails_cx((ProductDetails_styles_module_default()).addToCart, (ProductDetails_styles_module_default()).isOutOfStock),
                theme: colors/* GlobalThemeColors.Black */.b.Black,
                textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
                onClick: showContactPopin,
                children: t(dictionary/* CTA.SPECIAL_ORDER */.MV.SPECIAL_ORDER)
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton/* default */.Z, {
            className: ProductDetails_cx((ProductDetails_styles_module_default()).addToCart),
            onClick: addToCartActions,
            isOutOfStock: selectedVariant && isOutOfSkock,
            isPreOrder: enablePreOrder,
            cartItems: cartItems,
            theme: colors/* GlobalThemeColors.Black */.b.Black
        });
    };
    var renderSelectors = function(className, theme) {
        var ref;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHeader_ProductHeaderVariants, {
                    className: className,
                    variants: variants,
                    selectedVariant: selectedVariant,
                    setSelectedVariant: setSelectedVariant,
                    theme: theme !== null && theme !== void 0 ? theme : colors/* GlobalThemeColors.Black */.b.Black,
                    notes: global === null || global === void 0 ? void 0 : (ref = global.product) === null || ref === void 0 ? void 0 : ref.notes,
                    preOrder: enablePreOrder && preOrder,
                    isSpecialOrder: isSpecialOrder,
                    isStockAlert: isStockAlert,
                    isQuickbuy: isQuickbuy,
                    isAdjusting: isAdjusting,
                    adjustableOffset: adjustableOffset,
                    hasSizeGuide: !!sizeGuide,
                    sizeGuide: sizeGuide,
                    customProductState: customProductState,
                    setCustomProductState: setCustomProductState,
                    productVariations: productVariations
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: ProductDetails_cx((ProductDetails_styles_module_default()).cartContainer),
                    children: [
                        renderCtas(isStockAlert, isSpecialOrder, selectedVariant),
                        wishlistEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistIcon/* default */.Z, {
                            className: (ProductDetails_styles_module_default()).wishlistIcon,
                            trackingData: trackingData,
                            shopifyId: shopifyId,
                            variantId: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id,
                            productLink: link,
                            uuid: uuid
                        })
                    ]
                })
            ]
        });
    };
    // Rerendering sections depending on the shops availability for the selected variant
    var sectionsToRender = (0,_to_consumable_array/* default */.Z)((selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.shops) && (selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref1 = selectedVariant.shops) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? selectedVariant.shops : []).concat((0,_to_consumable_array/* default */.Z)(sections && (sections === null || sections === void 0 ? void 0 : sections.length) > 0 ? sections : []));
    var vatLabel = market === "UK" ? t(dictionary/* PRODUCT.TAXES_UK */.c5.TAXES_UK, {
        _: "VAT included"
    }) : market === "US" ? t(dictionary/* PRODUCT.TAXES_US */.c5.TAXES_US, {
        _: "taxes & duties included"
    }) : market === "EU" ? t(dictionary/* CART.TAXES_INCLUDED */.$L.TAXES_INCLUDED) : t(dictionary/* CART.TAXES_EXCLUDED */.$L.TAXES_EXCLUDED);
    var vatStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskRegular */.C.Text12GroteskRegular
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ProductDetails_cx((ProductDetails_styles_module_default()).ProductDetails, className, {
            isNavBannerVisible: isNavBannerVisible
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProductDetails_styles_module_default()).inViewMarker,
                ref: inViewTopMarkerRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default */.Z, {
                className: (ProductDetails_styles_module_default()).breadcrumb,
                theme: "product",
                color: colors/* GlobalThemeColors.Gray */.b.Gray,
                textPreset: text_preset/* GlobalTextPreset.Cta12GroteskRegular */.C.Cta12GroteskRegular,
                textStyling: text_styling/* GlobalTextStyling.Capitalize */.l.Capitalize
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: ProductDetails_cx((ProductDetails_styles_module_default()).wrapper),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductDetails_styles_module_default()).top,
                        children: [
                            productDesigner && /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                textPreset: text_preset/* GlobalTextPreset.Title20_24SangBleu */.C.Title20_24SangBleu,
                                textStyling: text_styling/* GlobalTextStyling.None */.l.None,
                                lineProps: {
                                    initialLineState: "none"
                                },
                                className: ProductDetails_cx((ProductDetails_styles_module_default()).link)
                            }, productDesigner), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: productDesigner === null || productDesigner === void 0 ? void 0 : productDesigner.children
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ProductDetails_styles_module_default()).topInfos,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: ProductDetails_cx((ProductDetails_styles_module_default()).title, titleStyle),
                                        children: productName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: ProductDetails_cx((ProductDetails_styles_module_default()).price, titleStyle),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: ProductDetails_cx((ProductDetails_styles_module_default()).vat, vatStyle),
                                                children: vatLabel
                                            }),
                                            (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.compareAtPrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)("del", {
                                                className: ProductDetails_cx((ProductDetails_styles_module_default()).compareAtPrice, compareAtStyle),
                                                children: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.compareAtPrice
                                            }),
                                            selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.price
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProductDetails_styles_module_default()).body,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: ProductDetails_cx((ProductDetails_styles_module_default()).ctasContainer),
                            children: renderSelectors((ProductDetails_styles_module_default()).mainSelector)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProductDetails_styles_module_default()).bottom,
                        children: [
                            description && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMoreText/* default */.Z, {
                                className: (ProductDetails_styles_module_default()).description,
                                charsLimit: 150,
                                text: description
                            }),
                            reference && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: ProductDetails_cx((ProductDetails_styles_module_default()).reference, textStyle),
                                children: reference
                            }),
                            sectionsToRender && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailsAccordion, {
                                className: (ProductDetails_styles_module_default()).sections,
                                items: sectionsToRender
                            }),
                            (global === null || global === void 0 ? void 0 : (ref2 = global.product) === null || ref2 === void 0 ? void 0 : ref2.reassurance) && /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_ProductReassurance, {
                                className: (ProductDetails_styles_module_default()).reassurance,
                                items: global === null || global === void 0 ? void 0 : (ref3 = global.product) === null || ref3 === void 0 ? void 0 : ref3.reassurance
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
ProductDetails.defaultProps = {};
/* harmony default export */ var ProductHeader_ProductDetails = (ProductDetails);

// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/FullScreenImage/index.js + 2 modules
var FullScreenImage = __webpack_require__(38206);
// EXTERNAL MODULE: ./src/components/Abstracts/Image/index.tsx + 3 modules
var Image = __webpack_require__(12745);
// EXTERNAL MODULE: ./src/components/Abstracts/Video/index.tsx
var Video = __webpack_require__(49013);
// EXTERNAL MODULE: ./src/components/UI/ProductSlider/index.tsx + 1 modules
var ProductSlider = __webpack_require__(2029);
// EXTERNAL MODULE: ./src/hooks/useBodyScrollLock/index.tsx + 1 modules
var useBodyScrollLock = __webpack_require__(38230);
// EXTERNAL MODULE: ./src/hooks/useBreakpoint/index.ts + 4 modules
var useBreakpoint = __webpack_require__(7695);
// EXTERNAL MODULE: ./src/components/UI/ProductHeader/ProductHeaderImages/styles.module.scss
var ProductHeaderImages_styles_module = __webpack_require__(17409);
var ProductHeaderImages_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductHeaderImages_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/ProductHeader/ProductHeaderImages/index.tsx















var ProductHeaderImages_cx = bind_default().bind((ProductHeaderImages_styles_module_default()));
var IMAGE_SIZES = [
    {
        breakpoint: "md",
        ratio: 13 / 24
    },
    {
        ratio: 1
    }
];
function ProductHeaderImages(param) {
    var className = param.className, items = param.items, mediaItems = param.mediaItems, variantsItems = param.variantsItems, variantIndex = param.variantIndex, productName = param.productName;
    var ref;
    var ref1 = (0,react.useState)(-1), fullScreenImageIndex = ref1[0], setFullScreenImageIndex = ref1[1];
    var isMobile = (0,useBreakpoint/* default */.Z)("md");
    var t = (0,lib/* useTranslate */.qM)();
    var customSliderRef = (0,react.useRef)();
    var ref2, ref3;
    var processedItems = (ref = [
        (ref3 = (ref2 = variantsItems === null || variantsItems === void 0 ? void 0 : variantsItems[variantIndex]) !== null && ref2 !== void 0 ? ref2 : variantsItems === null || variantsItems === void 0 ? void 0 : variantsItems[0]) !== null && ref3 !== void 0 ? ref3 : null, 
    ].concat((0,_to_consumable_array/* default */.Z)(mediaItems ? mediaItems : items))) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
        return item;
    });
    (0,useBodyScrollLock/* default */.Z)(fullScreenImageIndex >= 0);
    var renderItems = function(items) {
        return items === null || items === void 0 ? void 0 : items.map(function(item, index) {
            var ref, ref1;
            var imagePriority = index === 0 ? true : false;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: ProductHeaderImages_cx((ProductHeaderImages_styles_module_default()).item),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProductHeaderImages_styles_module_default()).ratio,
                    children: (item === null || item === void 0 ? void 0 : (ref = item.video) === null || ref === void 0 ? void 0 : ref.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Video/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: (ProductHeaderImages_styles_module_default()).video
                    }, item === null || item === void 0 ? void 0 : item.video), {
                        autoPlay: true,
                        loop: true,
                        muted: true,
                        playsInline: true,
                        objectFit: "cover"
                    })) : (item === null || item === void 0 ? void 0 : (ref1 = item.image) === null || ref1 === void 0 ? void 0 : ref1.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        className: (ProductHeaderImages_styles_module_default()).image
                    }, item === null || item === void 0 ? void 0 : item.image), {
                        sizesFromBreakpoints: IMAGE_SIZES,
                        layout: "fill",
                        objectFit: "cover",
                        asPlaceholder: true,
                        alt: productName,
                        priority: imagePriority,
                        loader: null,
                        onClick: function() {
                            return setFullScreenImageIndex(index);
                        }
                    })) : null
                })
            }, "image_video_".concat(index));
        });
    };
    var renderFullScreenImage = function() {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (ProductHeaderImages_styles_module_default()).fullScreenImage,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProductHeaderImages_styles_module_default()).controls,
                    onClick: function() {
                        return setFullScreenImageIndex(-1);
                    },
                    children: t("cta.close")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, items === null || items === void 0 ? void 0 : (ref = items[fullScreenImageIndex]) === null || ref === void 0 ? void 0 : ref.image), {
                    objectFit: "cover",
                    layout: "fill"
                }))
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenImage/* FullScreenImage */.z, {
            classes: {
                FullScreenImage: (ProductHeaderImages_styles_module_default()).fullScreenImage,
                controls: (ProductHeaderImages_styles_module_default()).controls
            },
            imageHeight: items === null || items === void 0 ? void 0 : (ref1 = items[fullScreenImageIndex]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.height,
            imageWidth: items === null || items === void 0 ? void 0 : (ref3 = items[fullScreenImageIndex]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.width,
            image: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, items === null || items === void 0 ? void 0 : (ref5 = items[fullScreenImageIndex]) === null || ref5 === void 0 ? void 0 : ref5.image), {
                objectFit: "cover",
                layout: "fill"
            })),
            closeComponent: t(dictionary/* PANEL.CLOSE */.Pq.CLOSE),
            onExitFullscreen: function() {
                setFullScreenImageIndex(-1);
            },
            xStartPercent: 50,
            yStartPercent: 50
        }, "fullScreen-image-".concat(items === null || items === void 0 ? void 0 : (ref6 = items[fullScreenImageIndex]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.image) === null || ref7 === void 0 ? void 0 : ref7.src));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ProductHeaderImages_cx((ProductHeaderImages_styles_module_default()).ProductHeaderImages, className),
        ref: customSliderRef,
        children: [
            fullScreenImageIndex > -1 ? renderFullScreenImage() : null,
            (processedItems === null || processedItems === void 0 ? void 0 : processedItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: ProductHeaderImages_cx((ProductHeaderImages_styles_module_default()).desktopImages, (ProductHeaderImages_styles_module_default()).hideOnSmallScreen),
                children: renderItems(processedItems)
            }),
            (processedItems === null || processedItems === void 0 ? void 0 : processedItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: ProductHeaderImages_cx((ProductHeaderImages_styles_module_default()).mobileImages, (ProductHeaderImages_styles_module_default()).hideOnLargeScreen),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSlider/* default */.Z, {
                    sliderClassName: (ProductHeaderImages_styles_module_default()).slider,
                    children: renderItems(processedItems)
                })
            })
        ]
    });
}
ProductHeaderImages.defaultProps = {};
/* harmony default export */ var ProductHeader_ProductHeaderImages = (ProductHeaderImages);

// EXTERNAL MODULE: ./src/components/UI/ProductTag/index.tsx
var ProductTag = __webpack_require__(25539);
// EXTERNAL MODULE: ./src/hooks/useProductStatusTagsValues/index.ts + 1 modules
var useProductStatusTagsValues = __webpack_require__(62231);
// EXTERNAL MODULE: ./src/utils/chunk.ts
var chunk = __webpack_require__(17972);
// EXTERNAL MODULE: ./src/components/UI/ProductHeader/ProductHeaderTags/styles.module.scss
var ProductHeaderTags_styles_module = __webpack_require__(81051);
var ProductHeaderTags_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductHeaderTags_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/ProductHeader/ProductHeaderTags/index.tsx












var ProductHeaderTags_cx = bind_default().bind((ProductHeaderTags_styles_module_default()));
var DEFAULT_MAX_SHOWN_TAGS = 3;
function ProductHeaderTags(param) {
    var className = param.className, productStatusTags = param.productStatusTags, sustainabilityTags = param.sustainabilityTags, customTags = param.customTags;
    var ref;
    var ref1 = (0,react.useState)(false), showAll = ref1[0], setShowAll = ref1[1];
    var t = (0,lib/* useTranslate */.qM)();
    var formattedStatusTags = (0,useProductStatusTagsValues/* default */.Z)(productStatusTags);
    var hasStatusTags = (formattedStatusTags === null || formattedStatusTags === void 0 ? void 0 : formattedStatusTags.length) > 0 || (customTags === null || customTags === void 0 ? void 0 : customTags.length) > 0;
    var hasSustainabilityTags = (sustainabilityTags === null || sustainabilityTags === void 0 ? void 0 : sustainabilityTags.length) > 0;
    var ref2;
    var tagsList = (ref2 = (0,_to_consumable_array/* default */.Z)(formattedStatusTags !== null && formattedStatusTags !== void 0 ? formattedStatusTags : []).concat((0,_to_consumable_array/* default */.Z)(customTags !== null && customTags !== void 0 ? customTags : []), (0,_to_consumable_array/* default */.Z)(sustainabilityTags !== null && sustainabilityTags !== void 0 ? sustainabilityTags : [])).filter(function(item) {
        return item;
    })) !== null && ref2 !== void 0 ? ref2 : [];
    var chunkedTags = (ref = (0,chunk/* default */.Z)(tagsList, showAll ? tagsList.length : DEFAULT_MAX_SHOWN_TAGS)) === null || ref === void 0 ? void 0 : ref[0];
    return hasStatusTags || hasSustainabilityTags ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ProductHeaderTags_cx((ProductHeaderTags_styles_module_default()).ProductHeaderTags, className),
        children: [
            (hasStatusTags || hasSustainabilityTags) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: ProductHeaderTags_cx((ProductHeaderTags_styles_module_default()).hideOnLargeScreen, (ProductHeaderTags_styles_module_default()).mobileTags),
                children: [
                    hasStatusTags && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: ProductHeaderTags_cx((ProductHeaderTags_styles_module_default()).statusTags, (ProductHeaderTags_styles_module_default()).column),
                        children: [
                            formattedStatusTags === null || formattedStatusTags === void 0 ? void 0 : formattedStatusTags.map(function(value, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTag/* default */.Z, {
                                    className: ProductHeaderTags_cx((ProductHeaderTags_styles_module_default()).tag),
                                    children: value
                                }, "status_tag_".concat(index));
                            }),
                            customTags === null || customTags === void 0 ? void 0 : customTags.map(function(value, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTag/* default */.Z, {
                                    className: ProductHeaderTags_cx((ProductHeaderTags_styles_module_default()).tag),
                                    children: value
                                }, "custom_status_tag_".concat(index));
                            })
                        ]
                    }),
                    hasSustainabilityTags && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: ProductHeaderTags_cx((ProductHeaderTags_styles_module_default()).sustainabilityTags, (ProductHeaderTags_styles_module_default()).column),
                        children: sustainabilityTags === null || sustainabilityTags === void 0 ? void 0 : sustainabilityTags.map(function(tag, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTag/* default */.Z, {
                                className: ProductHeaderTags_cx((ProductHeaderTags_styles_module_default()).tag),
                                children: tag
                            }, "sustainability_tag_".concat(index));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: ProductHeaderTags_cx((ProductHeaderTags_styles_module_default()).hideOnSmallScreen, (ProductHeaderTags_styles_module_default()).desktopTags),
                children: [
                    (chunkedTags === null || chunkedTags === void 0 ? void 0 : chunkedTags.length) > 0 && (chunkedTags === null || chunkedTags === void 0 ? void 0 : chunkedTags.map(function(tag, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTag/* default */.Z, {
                            className: ProductHeaderTags_cx((ProductHeaderTags_styles_module_default()).tag),
                            children: tag
                        }, "sustainability_tag_".concat(index));
                    })),
                    !showAll && (chunkedTags === null || chunkedTags === void 0 ? void 0 : chunkedTags.length) > DEFAULT_MAX_SHOWN_TAGS && /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, {
                        className: ProductHeaderTags_cx((ProductHeaderTags_styles_module_default()).viewMore),
                        textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
                        onClick: function() {
                            return setShowAll(true);
                        },
                        children: "".concat(t(dictionary/* CTA.VIEW_ALL */.MV.VIEW_ALL), " (+)")
                    })
                ]
            })
        ]
    }) : null;
}
ProductHeaderTags.defaultProps = {};
/* harmony default export */ var ProductHeader_ProductHeaderTags = (ProductHeaderTags);

// EXTERNAL MODULE: ./src/hooks/useGetProduct/index.ts
var useGetProduct = __webpack_require__(69992);
// EXTERNAL MODULE: ./src/hooks/useLocale/index.ts
var useLocale = __webpack_require__(66794);
// EXTERNAL MODULE: ./src/data/serialize-shopify-product-data.ts + 4 modules
var serialize_shopify_product_data = __webpack_require__(39294);
;// CONCATENATED MODULE: ./src/providers/ShopifyProductProvider/index.tsx







var ShopifyProductContext = /*#__PURE__*/ (0,react.createContext)({});
function ShopifyProductProvider(param) {
    var isAdjustable = param.isAdjustable, adjustableOffset = param.adjustableOffset, gid = param.gid, children = param.children;
    var locale = (0,useLocale/* default */.Z)();
    var ref = (0,useGetProduct/* useGetProduct */.K)({
        id: gid,
        includeQuantityAvailable: true,
        locale: locale
    }), product = ref.data, isLoading = ref.isLoading;
    var ref1;
    var shopifyProduct = (0,serialize_shopify_product_data/* serializeShopifyProductData */.u)({
        isAdjustable: isAdjustable,
        adjustableOffsetValue: adjustableOffset,
        productVariants: product === null || product === void 0 ? void 0 : product.variants,
        productImages: product === null || product === void 0 ? void 0 : product.images,
        shopifyProductId: product === null || product === void 0 ? void 0 : product.id,
        media: (ref1 = product === null || product === void 0 ? void 0 : product.media) !== null && ref1 !== void 0 ? ref1 : null,
        locale: locale
    });
    var processedValue = (0,react.useMemo)(function() {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, shopifyProduct), {
            isLoading: isLoading
        });
    }, [
        isLoading,
        JSON.stringify(shopifyProduct)
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopifyProductContext.Provider, {
        value: processedValue,
        children: children
    });
}
function useShopifyProductContext() {
    return (0,react.useContext)(ShopifyProductContext);
}

// EXTERNAL MODULE: ./src/providers/TrackerProvider/index.tsx + 1 modules
var TrackerProvider = __webpack_require__(34299);
// EXTERNAL MODULE: ./src/hooks/tracking/useTrackProductCardsList/index.ts
var useTrackProductCardsList = __webpack_require__(16211);
;// CONCATENATED MODULE: ./src/hooks/useFallbackVariants/index.ts


function useFallbackVariants(param) {
    var baseVariants = param.baseVariants, baseDefaultVariant = param.baseDefaultVariant, updatedVariants = param.updatedVariants, updatedDefaultVariant = param.updatedDefaultVariant, isUpdatedVariantsLoaded = param.isUpdatedVariantsLoaded, isVariantsEqual = param.isVariantsEqual;
    var memorizedValues = (0,react.useMemo)(function() {
        var variantsToUse = baseVariants;
        var defaultVariantToUse = baseDefaultVariant;
        // If I'm fully done loading variants
        if (isUpdatedVariantsLoaded) {
            // If the variants from the rest part and the updated ones are not deeply equal
            if (!isVariantsEqual) {
                // Then I'm attributing the variables to the updated ones I got from the server directly
                defaultVariantToUse = updatedDefaultVariant;
                variantsToUse = updatedVariants;
            }
        }
        return {
            isVariantsEqual: isVariantsEqual,
            isUpdatedVariantsLoaded: isUpdatedVariantsLoaded,
            variants: variantsToUse,
            defaultVariant: defaultVariantToUse
        };
    }, [
        isUpdatedVariantsLoaded,
        isVariantsEqual
    ]);
    return {
        fallbackVariantValues: memorizedValues,
        compiledVariantProps: (0,_object_spread/* default */.Z)({}, (memorizedValues === null || memorizedValues === void 0 ? void 0 : memorizedValues.isVariantsEqual) && (memorizedValues === null || memorizedValues === void 0 ? void 0 : memorizedValues.isUpdatedVariantsLoaded) ? {} : {
            variants: memorizedValues === null || memorizedValues === void 0 ? void 0 : memorizedValues.variants,
            defaultVariant: memorizedValues === null || memorizedValues === void 0 ? void 0 : memorizedValues.defaultVariant
        })
    };
}

;// CONCATENATED MODULE: ./src/hooks/useVariant/index.ts


function useVariant(variants, defaultVariant) {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(true), isAvailableForSale = ref[0], setIsAvailableForSale = ref[1];
    var ref1 = (0,react.useState)(), selectedVariant = ref1[0], setSelectedVariant = ref1[1];
    var queryKey = "variant";
    // First load issue with next query router, we checked the asPath to be sure the variant was in the url
    var regex = new RegExp("[&?]".concat(queryKey, "=(.*)(&|$)"));
    var matching = router.asPath.match(regex);
    var queryValue = router.query[queryKey] || matching ? matching === null || matching === void 0 ? void 0 : matching[1] : null;
    var ref2;
    queryValue = (ref2 = decodeURIComponent(queryValue === null || queryValue === void 0 ? void 0 : queryValue.replace(/\+/g, " "))) !== null && ref2 !== void 0 ? ref2 : null;
    var currentVariant = queryValue ? variants === null || variants === void 0 ? void 0 : variants.find(function(variant) {
        return (variant === null || variant === void 0 ? void 0 : variant.title) === queryValue;
    }) : null;
    (0,react.useEffect)(function() {
        var variant = currentVariant || defaultVariant;
        if (variant) setSelectedVariant(variant);
    }, [
        currentVariant,
        defaultVariant
    ]);
    (0,react.useEffect)(function() {
        var ref;
        var currentVariant = (ref = selectedVariant ? selectedVariant : variants ? variants === null || variants === void 0 ? void 0 : variants[0] : defaultVariant) !== null && ref !== void 0 ? ref : null;
        if (currentVariant) {
            setIsAvailableForSale(currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.availableForSale);
        }
    }, [
        selectedVariant,
        variants,
        defaultVariant
    ]);
    var variantIndex = variants === null || variants === void 0 ? void 0 : variants.findIndex(function(item) {
        return (item === null || item === void 0 ? void 0 : item.id) === (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id);
    });
    return {
        selectedVariant: selectedVariant,
        setSelectedVariant: setSelectedVariant,
        variantIndex: variantIndex,
        isAvailableForSale: isAvailableForSale
    };
}

// EXTERNAL MODULE: ./src/utils/deep-equal.ts
var deep_equal = __webpack_require__(72341);
;// CONCATENATED MODULE: ./src/utils/deep-equal-compare-variants.ts

/**
 * It takes a Variant and returns a ComparingVariant
 * @param {WbProductVariant} variant - Variant - this is the variant object that we're getting from the Shopify
 * API.
 * @returns An object with the properties sku, id, price, priceAmount, and availableForSale.
 */ function getOnlyNeededPropertiesFromVariants(variants) {
    var rewrittenVariants = variants === null || variants === void 0 ? void 0 : variants.map(function(variant, index) {
        return {
            sku: variant.sku,
            id: variant.id,
            price: variant.price,
            priceAmount: variant.priceAmount,
            availableForSale: variant.availableForSale
        };
    });
    return rewrittenVariants;
}
/**
 * It compares two variants and returns true if they are equal
 * @param {WbProductVariant} x - Variant - The first variant to compare
 * @param {WbProductVariant} y - Variant - the variant that we're comparing to
 * @returns A function that takes two arguments, x and y, and returns a boolean.
 */ function deepEqualCompareVariants(x, y) {
    if ((x === null || x === void 0 ? void 0 : x.length) > 0 && (y === null || y === void 0 ? void 0 : y.length) > 0) {
        var firstVariant = getOnlyNeededPropertiesFromVariants(x);
        var secondVariant = getOnlyNeededPropertiesFromVariants(y);
        return (0,deep_equal/* default */.Z)(firstVariant, secondVariant);
    } else {
        return false;
    }
}

// EXTERNAL MODULE: ./src/components/UI/ProductHeader/styles.module.scss
var ProductHeader_styles_module = __webpack_require__(77192);
var ProductHeader_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProductHeader_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/ProductHeader/index.tsx




















var ProductHeader_cx = bind_default().bind((ProductHeader_styles_module_default()));
function ProductHeader(_param) {
    var className = _param.className, items = _param.items, mediaItems = _param.mediaItems, variantsItems = _param.variantsItems, productVariations = _param.productVariations, productStatusTags = _param.productStatusTags, sustainabilityTags = _param.sustainabilityTags, trackingData = _param.trackingData, customTags = _param.customTags, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "items",
        "mediaItems",
        "variantsItems",
        "productVariations",
        "productStatusTags",
        "sustainabilityTags",
        "trackingData",
        "customTags"
    ]);
    var ref;
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var firstLoad = (0,react.useRef)(true);
    var tracker = (0,TrackerProvider/* useTracker */.Q4)();
    var ref1 = useShopifyProductContext(), updatedVariants = ref1.variants, updatedDefaultVariant = ref1.defaultVariant, isLoading = ref1.isLoading;
    var isVariantsEqual = deepEqualCompareVariants(updatedVariants, rest === null || rest === void 0 ? void 0 : rest.variants);
    var ref2 = useFallbackVariants({
        baseVariants: rest === null || rest === void 0 ? void 0 : rest.variants,
        baseDefaultVariant: rest === null || rest === void 0 ? void 0 : rest.defaultVariant,
        updatedVariants: updatedVariants,
        updatedDefaultVariant: updatedDefaultVariant,
        isUpdatedVariantsLoaded: !isLoading,
        isVariantsEqual: isVariantsEqual
    }), fallbackVariantValues = ref2.fallbackVariantValues, compiledVariantProps = ref2.compiledVariantProps;
    // Processed variant from routing param
    var ref3 = useVariant(fallbackVariantValues === null || fallbackVariantValues === void 0 ? void 0 : fallbackVariantValues.variants, fallbackVariantValues === null || fallbackVariantValues === void 0 ? void 0 : fallbackVariantValues.defaultVariant), selectedVariant = ref3.selectedVariant, variantIndex = ref3.variantIndex, setSelectedVariant = ref3.setSelectedVariant;
    var variantTrackingData = (0,react.useMemo)(function() {
        var ref;
        var price = +(selectedVariant === null || selectedVariant === void 0 ? void 0 : (ref = selectedVariant.unformattedPrice) === null || ref === void 0 ? void 0 : ref.amount);
        var ref1, ref2, ref3, ref4;
        return (0,_object_spread/* default */.Z)({}, (ref4 = (0,useTrackProductCardsList/* fromProductCardPropsToProductTrackingData */.w)({
            variantId: (ref1 = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.id) !== null && ref1 !== void 0 ? ref1 : null,
            sku: (ref2 = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sku) !== null && ref2 !== void 0 ? ref2 : "",
            size: (ref3 = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.title) !== null && ref3 !== void 0 ? ref3 : null,
            priceAmount: !isNaN(price) ? price : null
        }, {})) !== null && ref4 !== void 0 ? ref4 : {}, trackingData);
    }, [
        rest,
        selectedVariant
    ]);
    var triggerEvent = function(event) {
        tracker.emit(event, {
            origin: constants/* OriginType.DETAIL_VIEW */.F.DETAIL_VIEW,
            item: variantTrackingData
        });
    };
    (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function() {
        if (selectedVariant && firstLoad.current) {
            firstLoad.current = false;
            setTimeout(function() {
                return triggerEvent(constants/* TRACKING_EVENTS.PRODUCT_PAGE_VIEW */.Iy.PRODUCT_PAGE_VIEW);
            }, 0);
        }
    }, [
        selectedVariant
    ]);
    var mediaGallery = items && (items === null || items === void 0 ? void 0 : items.length) > 0 ? (0,_to_consumable_array/* default */.Z)(items) : [];
    var ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ProductHeader_cx((ProductHeader_styles_module_default()).ProductHeader, className, gridStyle),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHeader_ProductDetails, (0,_object_spread/* default */.Z)({
                className: ProductHeader_cx((ProductHeader_styles_module_default()).details),
                setSelectedVariant: setSelectedVariant,
                selectedVariant: selectedVariant !== null && selectedVariant !== void 0 ? selectedVariant : rest === null || rest === void 0 ? void 0 : rest.defaultVariant,
                productVariations: productVariations,
                onAddToCart: function() {
                    return triggerEvent(constants/* TRACKING_EVENTS.PRODUCT_ADD_TO_CART */.Iy.PRODUCT_ADD_TO_CART);
                },
                trackingData: variantTrackingData,
                firstImage: (ref4 = mediaGallery === null || mediaGallery === void 0 ? void 0 : (ref = mediaGallery[0]) === null || ref === void 0 ? void 0 : ref.image) !== null && ref4 !== void 0 ? ref4 : null
            }, rest, compiledVariantProps)),
            (mediaGallery === null || mediaGallery === void 0 ? void 0 : mediaGallery.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHeader_ProductHeaderImages, {
                        className: (ProductHeader_styles_module_default()).images,
                        items: mediaGallery,
                        mediaItems: mediaItems,
                        variantsItems: variantsItems,
                        variantIndex: variantIndex,
                        productName: rest === null || rest === void 0 ? void 0 : rest.productName
                    }),
                    (productStatusTags || sustainabilityTags || customTags) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductHeader_ProductHeaderTags, {
                        className: ProductHeader_cx((ProductHeader_styles_module_default()).tags),
                        productStatusTags: productStatusTags !== null && productStatusTags !== void 0 ? productStatusTags : null,
                        sustainabilityTags: sustainabilityTags !== null && sustainabilityTags !== void 0 ? sustainabilityTags : null,
                        customTags: customTags !== null && customTags !== void 0 ? customTags : []
                    })
                ]
            })
        ]
    });
}
ProductHeader.defaultProps = {};
/* harmony default export */ var UI_ProductHeader = (ProductHeader);

// EXTERNAL MODULE: ./src/components/Abstracts/Spinner/index.tsx
var Spinner = __webpack_require__(87407);
// EXTERNAL MODULE: ./src/components/UI/ProductCard/index.tsx + 8 modules
var ProductCard = __webpack_require__(23816);
// EXTERNAL MODULE: ./src/components/UI/RecentlyViewedProductsGrid/styles.module.scss
var RecentlyViewedProductsGrid_styles_module = __webpack_require__(86264);
var RecentlyViewedProductsGrid_styles_module_default = /*#__PURE__*/__webpack_require__.n(RecentlyViewedProductsGrid_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/RecentlyViewedProductsGrid/index.tsx












var RecentlyViewedProductsGrid_cx = bind_default().bind((RecentlyViewedProductsGrid_styles_module_default()));
function RecentlyViewedProductsGrid(param) {
    var className = param.className, items = param.items, isLoading = param.isLoading, hasUuidsToFetch = param.hasUuidsToFetch;
    var t = (0,lib/* useTranslate */.qM)();
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.TitleFluid38_144SangBleu */.C.TitleFluid38_144SangBleu
    });
    return hasUuidsToFetch && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: RecentlyViewedProductsGrid_cx((RecentlyViewedProductsGrid_styles_module_default()).RecentlyViewedProductsGrid, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: RecentlyViewedProductsGrid_cx((RecentlyViewedProductsGrid_styles_module_default()).top, gridStyle),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: RecentlyViewedProductsGrid_cx((RecentlyViewedProductsGrid_styles_module_default()).title, titleStyle),
                    children: t(dictionary/* PRODUCT.RECENTLY_VIEWED */.c5.RECENTLY_VIEWED)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: RecentlyViewedProductsGrid_cx((RecentlyViewedProductsGrid_styles_module_default()).body, gridStyle),
                children: [
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (RecentlyViewedProductsGrid_styles_module_default()).loadingPanel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                            className: (RecentlyViewedProductsGrid_styles_module_default()).spinner
                        })
                    }),
                    !isLoading && (items === null || items === void 0 ? void 0 : items.length) > 0 && (items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, (0,_object_spread/* default */.Z)({
                            className: (RecentlyViewedProductsGrid_styles_module_default()).item
                        }, item), "card_recently_".concat(index));
                    }))
                ]
            })
        ]
    });
}
RecentlyViewedProductsGrid.defaultProps = {};
/* harmony default export */ var UI_RecentlyViewedProductsGrid = (RecentlyViewedProductsGrid);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./src/lib/storyblok-types.ts
var storyblok_types = __webpack_require__(18685);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
;// CONCATENATED MODULE: ./src/hooks/useProductsRecentlyViewed/index.tsx




// Timestamp 24h
var DAY_TIMESTAMP = 1000 * 60 * 60 * 24;
function getRecentlyViewedProducts(ctx) {
    var cookieKey = ctx.cookieKey;
    var cookie = js_cookie/* default.get */.Z.get(cookieKey);
    return cookie ? JSON.parse(cookie) : {};
}
function getRecentlyViewedProductsFromLocale(locale, ctx) {
    return getRecentlyViewedProducts(ctx)[locale];
}
/**
 * Add DB new Item
 * @param uid
 * @param locale
 * @param DB
 */ function addUID(uid, locale, DB) {
    var item = {
        uid: uid,
        date: Date.now()
    };
    DB[locale].push(item);
    return DB;
}
/**
 * Remove DB Item
 * @param uid
 * @param locale
 * @param DB
 */ function removeUID(uid, locale, DB) {
    DB[locale] = DB[locale].filter(function(n) {
        return n.uid !== uid;
    });
    return DB;
}
/**
 * Update DB Existing Item date
 * @param uid
 * @param locale
 * @param DB
 */ function updateUID(uid, locale, DB) {
    var now = Date.now();
    var index = DB[locale].findIndex(function(n) {
        return n.uid === uid;
    });
    DB[locale][index].date = now;
}
function addProductViewed(uid, locale, ctx) {
    var expireDays = ctx.expireDays, maxProducts = ctx.maxProducts, cookieAge = ctx.cookieAge, cookieKey = ctx.cookieKey;
    var DB = getRecentlyViewedProducts(ctx);
    if (!DB[locale]) DB[locale] = [];
    if (DB[locale].findIndex(function(n) {
        return n.uid === uid;
    }) === -1) addUID(uid, locale, DB);
    else updateUID(uid, locale, DB);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Filter too old items and delete it
        for(var _iterator = Object.entries(DB)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], loc = _value[1];
            DB[key] = loc.filter(function(n) {
                return Date.now() < n.date + expireDays * DAY_TIMESTAMP;
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        // Reorder
        for(var _iterator1 = Object.entries(DB)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _value1 = (0,_sliced_to_array/* default */.Z)(_step1.value, 2), loc1 = _value1[1];
            loc1.sort(function(a, b) {
                return b.date - a.date;
            });
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        // Delete older items if > MAX_PRODUCTS_RECENTLY_VIEWED
        for(var _iterator2 = Object.entries(DB)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var _value2 = (0,_sliced_to_array/* default */.Z)(_step2.value, 2), loc2 = _value2[1];
            if (loc2.length > maxProducts) {
                DB[locale] = loc2.slice(0, maxProducts);
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    js_cookie/* default.set */.Z.set(cookieKey, JSON.stringify(DB), {
        expires: cookieAge
    });
}
// Fake UID set of datas
var RANDOMS_UID = (/* unused pure expression or super */ null && ([
    "bague-octogone-or-jaune",
    "bague-octogone-or-rose",
    "bague-octogone-or-blanc", 
]));
// Fake LOCALES
var LOCALES = (/* unused pure expression or super */ null && ([
    "fr-fr",
    "en-us"
]));
/**
 * Debug function to add random UID when traveling on website
 * @param ctx
 */ function addRandomUID(ctx) {
    var UID = RANDOMS_UID[randomIntFromInterval(0, RANDOMS_UID.length - 1)];
    var locale = LOCALES[randomIntFromInterval(0, LOCALES.length - 1)];
    addProductViewed(UID, locale, ctx);
}
function useProductsRecentlyViewed(locale, ctx) {
    var ref = (0,react.useState)([]), uids = ref[0], setUids = ref[1];
    (0,react.useEffect)(function() {
        if (locale && ctx) {
            var products = getRecentlyViewedProductsFromLocale(locale, ctx);
            if (products) setUids(products === null || products === void 0 ? void 0 : products.map(function(item) {
                return item === null || item === void 0 ? void 0 : item.uid;
            }));
        }
    }, [
        locale,
        ctx
    ]);
    return uids;
}

// EXTERNAL MODULE: ./src/hooks/useProductsRecentlyViewed/context.tsx
var context = __webpack_require__(63366);
// EXTERNAL MODULE: ./src/components/UI/RecentlyViewedWrapper/styles.module.scss
var RecentlyViewedWrapper_styles_module = __webpack_require__(20915);
var RecentlyViewedWrapper_styles_module_default = /*#__PURE__*/__webpack_require__.n(RecentlyViewedWrapper_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/RecentlyViewedWrapper/index.tsx














var RecentlyViewedWrapper_cx = bind_default().bind((RecentlyViewedWrapper_styles_module_default()));
function RecentlyViewedWrapper(param) {
    var className = param.className, Component = param.Component;
    var locale = (0,next_router.useRouter)().locale;
    var ProductViewedCtx = (0,react.useContext)(context/* ProductsViewedContext */.N);
    var document = (0,GlobalDataProvider/* useGlobalData */.U)().document;
    var uids = useProductsRecentlyViewed(locale, ProductViewedCtx).filter(function(item) {
        if (!document) return null;
        if (document.type === storyblok_types/* STORYBLOK_TYPES.PRODUCT */.nI.PRODUCT) return item !== "".concat(storyblok_types/* STORYBLOK_TYPES.PRODUCT */.nI.PRODUCT, "/").concat(document.uid);
        else return item;
    }).filter(function(item) {
        return item;
    });
    var ref = (0,useQuery/* useQuery */.a)([
        "products_recently_viewed"
    ].concat((0,_to_consumable_array/* default */.Z)(uids.map(function(item) {
        return "".concat(item, "-").concat(locale);
    }))), /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            if ((uids === null || uids === void 0 ? void 0 : uids.length) > 0) {
                return [
                    2,
                    (0,handle_api/* getRecentlyViewedProducts */.rv)({
                        payload: {
                            uids: uids.join(","),
                            locale: locale
                        }
                    })
                ];
            } else {
                return [
                    2,
                    []
                ];
            }
            return [
                2
            ];
        });
    })), result = ref.data, isLoading = ref.isLoading;
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        items: (ref1 = result === null || result === void 0 ? void 0 : result.items) !== null && ref1 !== void 0 ? ref1 : [],
        hasUuidsToFetch: (uids === null || uids === void 0 ? void 0 : uids.length) > 0,
        isLoading: isLoading,
        className: className
    });
}
RecentlyViewedWrapper.defaultProps = {};
/* harmony default export */ var UI_RecentlyViewedWrapper = (RecentlyViewedWrapper);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var qs_lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(qs_lib);
// EXTERNAL MODULE: ./src/components/UI/RecommendedProductsGrid/styles.module.scss
var RecommendedProductsGrid_styles_module = __webpack_require__(22760);
var RecommendedProductsGrid_styles_module_default = /*#__PURE__*/__webpack_require__.n(RecommendedProductsGrid_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/RecommendedProductsGrid/index.tsx





















var RecommendedProductsGrid_cx = bind_default().bind((RecommendedProductsGrid_styles_module_default()));
function RecommendedProductsGrid(param) {
    var className = param.className, recommendationData = param.recommendationData;
    var ref, ref1, ref2;
    var customSliderRef = (0,react.useRef)();
    var t = (0,lib/* useTranslate */.qM)();
    var lang = (0,useLang/* default */.Z)();
    var locale = (0,useLocale/* default */.Z)();
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.TitleFluid38_144SangBleu */.C.TitleFluid38_144SangBleu
    });
    var ref3 = (0,useQuery/* useQuery */.a)([
        "products_recommended",
        recommendationData === null || recommendationData === void 0 ? void 0 : (ref = recommendationData.currentStory) === null || ref === void 0 ? void 0 : ref.uuid
    ], /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (recommendationData === null || recommendationData === void 0 ? void 0 : (ref = recommendationData.currentStory) === null || ref === void 0 ? void 0 : ref.uuid) {
                return [
                    2,
                    (0,handle_api/* getRecommendedProducts */.VB)({
                        payload: {
                            query: lib_default().stringify((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, recommendationData), {
                                locale: locale,
                                lang: lang
                            }), {
                                encode: false
                            })
                        }
                    })
                ];
            } else {
                return [
                    2,
                    []
                ];
            }
            return [
                2
            ];
        });
    })), result = ref3.data, isLoading = ref3.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: RecommendedProductsGrid_cx((RecommendedProductsGrid_styles_module_default()).RecommendedProductsGrid, className, {
            hasNoResults: result && (result === null || result === void 0 ? void 0 : (ref1 = result.items) === null || ref1 === void 0 ? void 0 : ref1.length) === 0 && !isLoading
        }),
        ref: customSliderRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: RecommendedProductsGrid_cx((RecommendedProductsGrid_styles_module_default()).top, gridStyle),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: RecommendedProductsGrid_cx((RecommendedProductsGrid_styles_module_default()).title, titleStyle),
                    children: t(dictionary/* PRODUCT.RECOMMENDED_PRODUCT */.c5.RECOMMENDED_PRODUCT)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: RecommendedProductsGrid_cx((RecommendedProductsGrid_styles_module_default()).body, gridStyle),
                children: [
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (RecommendedProductsGrid_styles_module_default()).loadingPanel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                            className: (RecommendedProductsGrid_styles_module_default()).spinner
                        })
                    }),
                    (result === null || result === void 0 ? void 0 : (ref2 = result.items) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.ZP, {
                        className: RecommendedProductsGrid_cx((RecommendedProductsGrid_styles_module_default()).slider),
                        snap: true,
                        customSliderRef: customSliderRef,
                        children: result === null || result === void 0 ? void 0 : result.items.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* default */.Z, (0,_object_spread/* default */.Z)({
                                className: (RecommendedProductsGrid_styles_module_default()).item
                            }, item), "card_recommended_".concat(index));
                        })
                    })
                ]
            })
        ]
    });
}
RecommendedProductsGrid.defaultProps = {};
/* harmony default export */ var UI_RecommendedProductsGrid = (RecommendedProductsGrid);

// EXTERNAL MODULE: ./src/pages/products/styles.module.scss
var products_styles_module = __webpack_require__(2502);
var products_styles_module_default = /*#__PURE__*/__webpack_require__.n(products_styles_module);
;// CONCATENATED MODULE: ./src/pages/products/[uid].tsx
















var __N_SSG = true;
function _uid_Product(param) {
    var slices = param.slices, productHeader = param.productHeader, currentProduct = param.currentProduct, recommendationData = param.recommendationData;
    var ref;
    var ProductViewedCtx = (0,react.useContext)(context/* ProductsViewedContext */.N);
    (0,react.useEffect)(function() {
        if ((currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.uid) && (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.locale)) {
            addProductViewed(currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.uid, currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.locale, ProductViewedCtx);
        }
    }, [
        currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.uid,
        currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.locale,
        ProductViewedCtx
    ]);
    var ref1 = (0,dist/* useInView */.YD)({
        threshold: 0.2,
        initialInView: true
    }), inViewBottomMarkerRef = ref1.ref, markerInViewBottom = ref1.inView, entry = ref1.entry;
    // Making sure even if we pass the marker that the footer is still mark visibled
    var isVisible = markerInViewBottom || (entry === null || entry === void 0 ? void 0 : (ref = entry.boundingClientRect) === null || ref === void 0 ? void 0 : ref.y) <= 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (productHeader === null || productHeader === void 0 ? void 0 : productHeader.jsonLD) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Product/* ProductData */.e, (0,_object_spread/* default */.Z)({}, productHeader.jsonLD)),
            productHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopifyProductProvider, {
                gid: productHeader === null || productHeader === void 0 ? void 0 : productHeader.shopifyId,
                isAdjustable: productHeader === null || productHeader === void 0 ? void 0 : productHeader.isAdjusting,
                adjustableOffset: productHeader === null || productHeader === void 0 ? void 0 : productHeader.adjustableOffset,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_ProductHeader, (0,_object_spread/* default */.Z)({
                    isFooterVisible: isVisible
                }, productHeader))
            }),
            recommendationData && ((recommendationData === null || recommendationData === void 0 ? void 0 : recommendationData.categoryUUID) || (recommendationData === null || recommendationData === void 0 ? void 0 : recommendationData.designerUUID) || (recommendationData === null || recommendationData === void 0 ? void 0 : recommendationData.siblingsStories)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_RecommendedProductsGrid, {
                recommendationData: recommendationData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_RecentlyViewedWrapper, {
                Component: UI_RecentlyViewedProductsGrid
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceManager/* default */.Z, {
                mapSliceTypeToComponent: product_page,
                slicesData: slices
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (products_styles_module_default()).inViewMarker,
                ref: inViewBottomMarkerRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageViewAnalytics/* PageViewAnalytics */.W, {
                template: "product"
            })
        ]
    });
}


/***/ }),

/***/ 11216:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"styles_Breadcrumb__ECBCq","item":"styles_item__bsSPJ"};

/***/ }),

/***/ 38250:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Video":"styles_Video__g4hI8"};

/***/ }),

/***/ 24627:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RecaptchaHandler":"styles_RecaptchaHandler__kL0nT","marker":"styles_marker__MNiHY"};

/***/ }),

/***/ 51307:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AlertStockPopin":"styles_AlertStockPopin__WfzHE","header":"styles_header__ADkwM","content":"styles_content__dtW9L","title":"styles_title__JMzQJ","text":"styles_text__JdpZG","inputContainer":"styles_inputContainer__3DkgN","marketing":"styles_marketing__kALiM","button":"styles_button__04b8s"};

/***/ }),

/***/ 15028:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumb":"styles_Breadcrumb__oIqn4","separator":"styles_separator__7OrSY","noLink":"styles_noLink___CVAf","theme-product":"styles_theme-product____PPg","item":"styles_item__HEs7j","active":"styles_active__eYmni","theme-footer":"styles_theme-footer__yoSLo"};

/***/ }),

/***/ 71843:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"alertStockIconClose":"styles_alertStockIconClose__ZqsfS","ProductDetails":"styles_ProductDetails__igymI","whiteTheme":"styles_whiteTheme__uIIEG","blackTheme":"styles_blackTheme__FzMs0","concreteTheme":"styles_concreteTheme__ntm3a","scorpionTheme":"styles_scorpionTheme__BOyrU","silver-chaliceTheme":"styles_silver-chaliceTheme__8eOgs","altoTheme":"styles_altoTheme__60tZz","silverTheme":"styles_silverTheme__HjpaN","grayTheme":"styles_grayTheme__BirGq","cod-grayTheme":"styles_cod-grayTheme__ZguHn","mine-shaftTheme":"styles_mine-shaftTheme__k1AS9","williamTheme":"styles_williamTheme__sRRlB","redTheme":"styles_redTheme__fz3ed","eunryTheme":"styles_eunryTheme___Acpu","irish-coffeeTheme":"styles_irish-coffeeTheme__Hk3NQ","amberTheme":"styles_amberTheme__YFWgz","transparentTheme":"styles_transparentTheme__OYYMw","isNavBannerVisible":"styles_isNavBannerVisible__1EWfW","wrapper":"styles_wrapper__eFnyj","breadcrumb":"styles_breadcrumb__rSC_t","top":"styles_top__IZeTs","link":"styles_link__ze7BS","topInfos":"styles_topInfos__Mfzue","title":"styles_title__1aNW9","price":"styles_price__iCLQi","vat":"styles_vat__B5dJ_","compareAtPrice":"styles_compareAtPrice__mZ2dq","body":"styles_body__qbU2I","mainSelector":"styles_mainSelector__JWZwc","cartContainer":"styles_cartContainer__aIZXk","wishlistIcon":"styles_wishlistIcon__BcQIb","addToCart":"styles_addToCart__1l5Jp","bottom":"styles_bottom__bNV09","description":"styles_description__9snOM","reference":"styles_reference__qUrK_","sections":"styles_sections__qIe0L","panelHead":"styles_panelHead__KdL1I","icon":"styles_icon__tXMAL","isActive":"styles_isActive__2im2B","panelBody":"styles_panelBody__YSudc","popin":"styles_popin__TOnjz"};

/***/ }),

/***/ 5096:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductDetailsBottomInformations":"styles_ProductDetailsBottomInformations__HC8k2","top":"styles_top__PGonX","bottom":"styles_bottom__VA5pC","textInfos":"styles_textInfos__o6wEd","size":"styles_size___GatW","isOutOfStock":"styles_isOutOfStock__yojWt","toggleSizeGuide":"styles_toggleSizeGuide__v11Ya","sizeGuideButton":"styles_sizeGuideButton__2zZ9n","hasInteracted":"styles_hasInteracted__vyO9s","note":"styles_note__JeggZ","noteTitle":"styles_noteTitle__Kez9B","noteText":"styles_noteText__Q_P9n"};

/***/ }),

/***/ 17409:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductHeaderImages":"styles_ProductHeaderImages__VEiMk","hideOnSmallScreen":"styles_hideOnSmallScreen__U_Ie0","hideOnLargeScreen":"styles_hideOnLargeScreen___fMu1","fullScreenImage":"styles_fullScreenImage__GWPdP","controls":"styles_controls__tP_FX","mobileImages":"styles_mobileImages__SEfP9","slider":"styles_slider__AC83h","item":"styles_item__ijNtI","image":"styles_image__mS8tG","video":"styles_video__wpaz6","ratio":"styles_ratio__cJIvM"};

/***/ }),

/***/ 81051:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductHeaderTags":"styles_ProductHeaderTags__lNoFZ","hideOnSmallScreen":"styles_hideOnSmallScreen__i8NND","hideOnLargeScreen":"styles_hideOnLargeScreen__qwN_D","desktopTags":"styles_desktopTags__7Ict5","mobileTags":"styles_mobileTags__jACTT","column":"styles_column__XNxfB","viewMore":"styles_viewMore__xzkoJ","tag":"styles_tag__TxyUZ"};

/***/ }),

/***/ 37870:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductHeaderVariants":"styles_ProductHeaderVariants__qhMI6","hideOnSmallScreen":"styles_hideOnSmallScreen__iC32O","hideOnLargeScreen":"styles_hideOnLargeScreen__Z8k9H","sizeSelect":"styles_sizeSelect__Hei37","select":"styles_select__9BTYO","variantPrice":"styles_variantPrice__wJ6UE","bottomInformations":"styles_bottomInformations__qr4cL","hasVariants":"styles_hasVariants__yIfpn"};

/***/ }),

/***/ 39641:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductSliderSelect":"styles_ProductSliderSelect__fZeQW","hasArrows":"styles_hasArrows__qStAV","wrapper":"styles_wrapper__tDFrV","button":"styles_button__5rczm","isSelected":"styles_isSelected__TZ8vA","isDisabled":"styles_isDisabled__Ekk6q","isOutOfStock":"styles_isOutOfStock__EhUsW","theme-large":"styles_theme-large__uTuSs","theme-small":"styles_theme-small__ZC8Dd","sliderArrow":"styles_sliderArrow__Cb5pv"};

/***/ }),

/***/ 75278:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductHeader":"styles_ProductHeader__78XWc","details":"styles_details__zfRqv","images":"styles_images__p2f_X","tags":"styles_tags__yl1fR"};

/***/ }),

/***/ 63464:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProductReassurance":"styles_ProductReassurance__j3roT","wrapper":"styles_wrapper__EQYrA","slider":"styles_slider__osW_L","item":"styles_item__GFAAB","separator":"styles_separator__bTAuF"};

/***/ }),

/***/ 10052:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ReadMoreText":"styles_ReadMoreText__4JKeQ","textItem":"styles_textItem__DJgVF"};

/***/ }),

/***/ 86264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RecentlyViewedProductsGrid":"styles_RecentlyViewedProductsGrid__qyazi","top":"styles_top__S4Ncl","body":"styles_body__QIFAA","title":"styles_title__FeNKm","item":"styles_item__KuQTY","loadingPanel":"styles_loadingPanel__89j8R","spinner":"styles_spinner__n2KfE"};

/***/ }),

/***/ 20915:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 22760:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RecommendedProductsGrid":"styles_RecommendedProductsGrid__432gD","hasNoResults":"styles_hasNoResults__MCUiT","top":"styles_top__19F8H","body":"styles_body__oQfkB","title":"styles_title__o_Dor","slider":"styles_slider__XgXcy","item":"styles_item__7uiyQ","loadingPanel":"styles_loadingPanel__d0OTZ","spinner":"styles_spinner__mumjZ"};

/***/ }),

/***/ 28657:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SliderArrow":"styles_SliderArrow__XXzdq","arrowIcon":"styles_arrowIcon__bhZ5T"};

/***/ }),

/***/ 99930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sliderArrow":"styles_sliderArrow__uBznL","leftArrow":"styles_leftArrow__dvsFU","inside":"styles_inside__a3Az5","rightArrow":"styles_rightArrow__epzEr"};

/***/ }),

/***/ 2502:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inViewMarker":"styles_inViewMarker__ty2yH"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7924,7130,2962,4623,2873,3816,9774,2888,179], function() { return __webpack_exec__(93319); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);